
export const V1_LICENCE_IDS = Object.freeze({
    AURA_ENTRY_TIER1_STANDARD_SUBSCRIPTION: 1,
    AURA_STANDARD_TIER1_STANDARD_SUBSCRIPTION: 2,
    AURA_PREMIUM_TIER1_STANDARD_SUBSCRIPTION: 3,
    AURA_ATTENDANT_TIER1_STANDARD_SUBSCRIPTION: 4,
    AURA_ENTRY_TIER2_STANDARD_SUBSCRIPTION: 5,
    AURA_STANDARD_TIER2_STANDARD_SUBSCRIPTION: 6,
    AURA_PREMIUM_TIER2_STANDARD_SUBSCRIPTION: 7,
    AURA_ATTENDANT_TIER2_STANDARD_SUBSCRIPTION: 8,
    AURA_ENTRY_TIER3_STANDARD_SUBSCRIPTION: 9,
    AURA_STANDARD_TIER3_STANDARD_SUBSCRIPTION: 10,
    AURA_PREMIUM_TIER3_STANDARD_SUBSCRIPTION: 11,
    AURA_ATTENDANT_TIER3_STANDARD_SUBSCRIPTION: 12,
    AURA_ENTRY_TIER1_PREMIUM_SUBSCRIPTION: 13,
    AURA_STANDARD_TIER1_PREMIUM_SUBSCRIPTION: 14,
    AURA_PREMIUM_TIER1_PREMIUM_SUBSCRIPTION: 15,
    AURA_ATTENDANT_TIER1_PREMIUM_SUBSCRIPTION: 16,
    AURA_ENTRY_TIER2_PREMIUM_SUBSCRIPTION: 17,
    AURA_STANDARD_TIER2_PREMIUM_SUBSCRIPTION: 18,
    AURA_PREMIUM_TIER2_PREMIUM_SUBSCRIPTION: 19,
    AURA_ATTENDANT_TIER2_PREMIUM_SUBSCRIPTION: 20,
    AURA_ENTRY_TIER3_PREMIUM_SUBSCRIPTION: 21,
    AURA_STANDARD_TIER3_PREMIUM_SUBSCRIPTION: 22,
    AURA_PREMIUM_TIER3_PREMIUM_SUBSCRIPTION: 23,
    AURA_ATTENDANT_TIER3_PREMIUM_SUBSCRIPTION: 24,
    AURA_ENTRY_TIER1_STANDARD_PERPETUAL: 25,
    AURA_STANDARD_TIER1_STANDARD_PERPETUAL: 26,
    AURA_PREMIUM_TIER1_STANDARD_PERPETUAL: 27,
    AURA_ATTENDANT_TIER1_STANDARD_PERPETUAL: 28,
    AURA_ENTRY_TIER2_STANDARD_PERPETUAL: 29,
    AURA_STANDARD_TIER2_STANDARD_PERPETUAL: 30,
    AURA_PREMIUM_TIER2_STANDARD_PERPETUAL: 31,
    AURA_ATTENDANT_TIER2_STANDARD_PERPETUAL: 32,
    AURA_ENTRY_TIER3_STANDARD_PERPETUAL: 33,
    AURA_STANDARD_TIER3_STANDARD_PERPETUAL: 34,
    AURA_PREMIUM_TIER3_STANDARD_PERPETUAL: 35,
    AURA_ATTENDANT_TIER3_STANDARD_PERPETUAL: 36,
    AURA_ENTRY_TIER1_PREMIUM_PERPETUAL: 37,
    AURA_STANDARD_TIER1_PREMIUM_PERPETUAL: 38,
    AURA_PREMIUM_TIER1_PREMIUM_PERPETUAL: 39,
    AURA_ATTENDANT_TIER1_PREMIUM_PERPETUAL: 40,
    AURA_ENTRY_TIER2_PREMIUM_PERPETUAL: 41,
    AURA_STANDARD_TIER2_PREMIUM_PERPETUAL: 42,
    AURA_PREMIUM_TIER2_PREMIUM_PERPETUAL: 43,
    AURA_ATTENDANT_TIER2_PREMIUM_PERPETUAL: 44,
    AURA_ENTRY_TIER3_PREMIUM_PERPETUAL: 45,
    AURA_STANDARD_TIER3_PREMIUM_PERPETUAL: 46,
    AURA_PREMIUM_TIER3_PREMIUM_PERPETUAL: 47,
    AURA_ATTENDANT_TIER3_PREMIUM_PERPETUAL: 48,
    ELITE_VOICE_TIER1_STANDARD_SUBSCRIPTION: 49,
    ELITE_VOICE_TIER2_STANDARD_SUBSCRIPTION: 50,
    ELITE_VOICE_TIER3_STANDARD_SUBSCRIPTION: 51,
    ELITE_VOICE_TIER1_PREMIUM_SUBSCRIPTION: 52,
    ELITE_VOICE_TIER2_PREMIUM_SUBSCRIPTION: 53,
    ELITE_VOICE_TIER3_PREMIUM_SUBSCRIPTION: 54,
    AVAYA_HANDSET_J129: 55,
    AVAYA_HANDSET_J139: 56,
    AVAYA_HANDSET_J169: 57,
    AVAYA_HANDSET_J179: 58,
    SIP_ACTIVE_12_DO_NOT_USE: 59,
    SIP_STANDBY_12_DO_NOT_USE: 60,
    REDBOX_CHANNEL: 62,
    REDBOX_SUPPORT_3RD_LINE: 63,
    REDBOX_SUPPORT_FULL: 64,
    RIGHTFAX: 65,
    DATATRACK_CDR: 66,
    CALLMEDIA_VOICE: 67,
    CALLMEDIA_MULTI_CHANNEL: 68,
    CALLMEDIA_OUTBOUND: 69,
    AURA_ENTRY_TIER1_STANDARD_SURRENDER: 70,
    AURA_STANDARD_TIER1_STANDARD_SURRENDER: 71,
    AURA_PREMIUM_TIER1_STANDARD_SURRENDER: 72,
    AURA_ATTENDANT_TIER1_STANDARD_SURRENDER: 73,
    AURA_ENTRY_TIER2_STANDARD_SURRENDER: 74,
    AURA_STANDARD_TIER2_STANDARD_SURRENDER: 75,
    AURA_PREMIUM_TIER2_STANDARD_SURRENDER: 76,
    AURA_ATTENDANT_TIER2_STANDARD_SURRENDER: 77,
    AURA_ENTRY_TIER3_STANDARD_SURRENDER: 78,
    AURA_STANDARD_TIER3_STANDARD_SURRENDER: 79,
    AURA_PREMIUM_TIER3_STANDARD_SURRENDER: 80,
    AURA_ATTENDANT_TIER3_STANDARD_SURRENDER: 81,
    AURA_ENTRY_TIER1_PREMIUM_SURRENDER: 82,
    AURA_STANDARD_TIER1_PREMIUM_SURRENDER: 83,
    AURA_PREMIUM_TIER1_PREMIUM_SURRENDER: 84,
    AURA_ATTENDANT_TIER1_PREMIUM_SURRENDER: 85,
    AURA_ENTRY_TIER2_PREMIUM_SURRENDER: 86,
    AURA_STANDARD_TIER2_PREMIUM_SURRENDER: 87,
    AURA_PREMIUM_TIER2_PREMIUM_SURRENDER: 88,
    AURA_ATTENDANT_TIER2_PREMIUM_SURRENDER: 89,
    AURA_ENTRY_TIER3_PREMIUM_SURRENDER: 90,
    AURA_STANDARD_TIER3_PREMIUM_SURRENDER: 91,
    AURA_PREMIUM_TIER3_PREMIUM_SURRENDER: 92,
    AURA_ATTENDANT_TIER3_PREMIUM_SURRENDER: 93,
    DATATRACK_TIER1: 94,
    DATATRACK_TIER2: 95,
    DATATRACK_TIER3: 96,
    ELITE_VOICE_TIER1_STANDARD_PERPETUAL: 97,
    ELITE_VOICE_TIER2_STANDARD_PERPETUAL: 98,
    ELITE_VOICE_TIER3_STANDARD_PERPETUAL: 99,
    ELITE_VOICE_TIER1_PREMIUM_PERPETUAL: 100,
    ELITE_VOICE_TIER2_PREMIUM_PERPETUAL: 101,
    ELITE_VOICE_TIER3_PREMIUM_PERPETUAL: 102,
    ELITE_VOICE_TIER1_PREMIUM_SURRENDER: 103,
    ELITE_VOICE_TIER2_PREMIUM_SURRENDER: 104,
    ELITE_VOICE_TIER3_PREMIUM_SURRENDER: 105,
    ELITE_VOICE_TIER1_STANDARD_SURRENDER: 106,
    ELITE_VOICE_TIER2_STANDARD_SURRENDER: 107,
    ELITE_VOICE_TIER3_STANDARD_SURRENDER: 108,
    MITEL_UC_BASIC_TIER1_STANDARD_SUBSCRIPTION: 109,
    MITEL_UC_ENTRY_TIER1_STANDARD_SUBSCRIPTION: 110,
    MITEL_UC_STANDARD_TIER1_STANDARD_SUBSCRIPTION: 111,
    MITEL_UC_PREMIUM_TIER1_STANDARD_SUBSCRIPTION: 112,
    MITEL_UC_ULTIMATE_TIER1_STANDARD_SUBSCRIPTION: 113,
    MITEL_UC_ATTENDANT_TIER1_STANDARD_SUBSCRIPTION: 114,
    MITEL_UC_ANALOGUE_TIER1_STANDARD_SUBSCRIPTION: 115,
    MITEL_UC_BASIC_TIER2_STANDARD_SUBSCRIPTION: 116,
    MITEL_UC_ENTRY_TIER2_STANDARD_SUBSCRIPTION: 117,
    MITEL_UC_STANDARD_TIER2_STANDARD_SUBSCRIPTION: 118,
    MITEL_UC_PREMIUM_TIER2_STANDARD_SUBSCRIPTION: 119,
    MITEL_UC_ULTIMATE_TIER2_STANDARD_SUBSCRIPTION: 120,
    MITEL_UC_ATTENDANT_TIER2_STANDARD_SUBSCRIPTION: 121,
    MITEL_UC_ANALOGUE_TIER2_STANDARD_SUBSCRIPTION: 122,
    MITEL_UC_BASIC_TIER3_STANDARD_SUBSCRIPTION: 123,
    MITEL_UC_ENTRY_TIER3_STANDARD_SUBSCRIPTION: 124,
    MITEL_UC_STANDARD_TIER3_STANDARD_SUBSCRIPTION: 125,
    MITEL_UC_PREMIUM_TIER3_STANDARD_SUBSCRIPTION: 126,
    MITEL_UC_ULTIMATE_TIER3_STANDARD_SUBSCRIPTION: 127,
    MITEL_UC_ATTENDANT_TIER3_STANDARD_SUBSCRIPTION: 128,
    MITEL_UC_ANALOGUE_TIER3_STANDARD_SUBSCRIPTION: 129,
    MITEL_UC_BASIC_TIER1_PREMIUM_SUBSCRIPTION: 130,
    MITEL_UC_ENTRY_TIER1_PREMIUM_SUBSCRIPTION: 131,
    MITEL_UC_STANDARD_TIER1_PREMIUM_SUBSCRIPTION: 132,
    MITEL_UC_PREMIUM_TIER1_PREMIUM_SUBSCRIPTION: 133,
    MITEL_UC_ULTIMATE_TIER1_PREMIUM_SUBSCRIPTION: 134,
    MITEL_UC_ATTENDANT_TIER1_PREMIUM_SUBSCRIPTION: 135,
    MITEL_UC_ANALOGUE_TIER1_PREMIUM_SUBSCRIPTION: 136,
    MITEL_UC_BASIC_TIER2_PREMIUM_SUBSCRIPTION: 137,
    MITEL_UC_ENTRY_TIER2_PREMIUM_SUBSCRIPTION: 138,
    MITEL_UC_STANDARD_TIER2_PREMIUM_SUBSCRIPTION: 139,
    MITEL_UC_PREMIUM_TIER2_PREMIUM_SUBSCRIPTION: 140,
    MITEL_UC_ULTIMATE_TIER2_PREMIUM_SUBSCRIPTION: 141,
    MITEL_UC_ATTENDANT_TIER2_PREMIUM_SUBSCRIPTION: 142,
    MITEL_UC_ANALOGUE_TIER2_PREMIUM_SUBSCRIPTION: 143,
    MITEL_UC_BASIC_TIER3_PREMIUM_SUBSCRIPTION: 144,
    MITEL_UC_ENTRY_TIER3_PREMIUM_SUBSCRIPTION: 145,
    MITEL_UC_STANDARD_TIER3_PREMIUM_SUBSCRIPTION: 146,
    MITEL_UC_PREMIUM_TIER3_PREMIUM_SUBSCRIPTION: 147,
    MITEL_UC_ULTIMATE_TIER3_PREMIUM_SUBSCRIPTION: 148,
    MITEL_UC_ATTENDANT_TIER3_PREMIUM_SUBSCRIPTION: 149,
    MITEL_UC_ANALOGUE_TIER3_PREMIUM_SUBSCRIPTION: 150,
    MITEL_UC_BASIC_TIER1_STANDARD_PERPETUAL: 151,
    MITEL_UC_ENTRY_TIER1_STANDARD_PERPETUAL: 152,
    MITEL_UC_STANDARD_TIER1_STANDARD_PERPETUAL: 153,
    MITEL_UC_PREMIUM_TIER1_STANDARD_PERPETUAL: 154,
    MITEL_UC_ULTIMATE_TIER1_STANDARD_PERPETUAL: 155,
    MITEL_UC_ATTENDANT_TIER1_STANDARD_PERPETUAL: 156,
    MITEL_UC_ANALOGUE_TIER1_STANDARD_PERPETUAL: 157,
    MITEL_UC_BASIC_TIER2_STANDARD_PERPETUAL: 158,
    MITEL_UC_ENTRY_TIER2_STANDARD_PERPETUAL: 159,
    MITEL_UC_STANDARD_TIER2_STANDARD_PERPETUAL: 160,
    MITEL_UC_PREMIUM_TIER2_STANDARD_PERPETUAL: 161,
    MITEL_UC_ULTIMATE_TIER2_STANDARD_PERPETUAL: 162,
    MITEL_UC_ATTENDANT_TIER2_STANDARD_PERPETUAL: 163,
    MITEL_UC_ANALOGUE_TIER2_STANDARD_PERPETUAL: 164,
    MITEL_UC_BASIC_TIER3_STANDARD_PERPETUAL: 165,
    MITEL_UC_ENTRY_TIER3_STANDARD_PERPETUAL: 166,
    MITEL_UC_STANDARD_TIER3_STANDARD_PERPETUAL: 167,
    MITEL_UC_PREMIUM_TIER3_STANDARD_PERPETUAL: 168,
    MITEL_UC_ULTIMATE_TIER3_STANDARD_PERPETUAL: 169,
    MITEL_UC_ATTENDANT_TIER3_STANDARD_PERPETUAL: 170,
    MITEL_UC_ANALOGUE_TIER3_STANDARD_PERPETUAL: 171,
    MITEL_UC_BASIC_TIER1_PREMIUM_PERPETUAL: 172,
    MITEL_UC_ENTRY_TIER1_PREMIUM_PERPETUAL: 173,
    MITEL_UC_STANDARD_TIER1_PREMIUM_PERPETUAL: 174,
    MITEL_UC_PREMIUM_TIER1_PREMIUM_PERPETUAL: 175,
    MITEL_UC_ULTIMATE_TIER1_PREMIUM_PERPETUAL: 176,
    MITEL_UC_ATTENDANT_TIER1_PREMIUM_PERPETUAL: 177,
    MITEL_UC_ANALOGUE_TIER1_PREMIUM_PERPETUAL: 178,
    MITEL_UC_BASIC_TIER2_PREMIUM_PERPETUAL: 179,
    MITEL_UC_ENTRY_TIER2_PREMIUM_PERPETUAL: 180,
    MITEL_UC_STANDARD_TIER2_PREMIUM_PERPETUAL: 181,
    MITEL_UC_PREMIUM_TIER2_PREMIUM_PERPETUAL: 182,
    MITEL_UC_ULTIMATE_TIER2_PREMIUM_PERPETUAL: 183,
    MITEL_UC_ATTENDANT_TIER2_PREMIUM_PERPETUAL: 184,
    MITEL_UC_ANALOGUE_TIER2_PREMIUM_PERPETUAL: 185,
    MITEL_UC_BASIC_TIER3_PREMIUM_PERPETUAL: 186,
    MITEL_UC_ENTRY_TIER3_PREMIUM_PERPETUAL: 187,
    MITEL_UC_STANDARD_TIER3_PREMIUM_PERPETUAL: 188,
    MITEL_UC_PREMIUM_TIER3_PREMIUM_PERPETUAL: 189,
    MITEL_UC_ULTIMATE_TIER3_PREMIUM_PERPETUAL: 190,
    MITEL_UC_ATTENDANT_TIER3_PREMIUM_PERPETUAL: 191,
    MITEL_UC_ANALOGUE_TIER3_PREMIUM_PERPETUAL: 192,
    MITEL_CC_VOICE_AGENT_TIER1_STANDARD_SUBSCRIPTION: 193,
    MITEL_CC_MULTIMEDIA_AGENT_TIER1_STANDARD_SUBSCRIPTION: 194,
    MITEL_CC_VOICE_AGENT_TIER2_STANDARD_SUBSCRIPTION: 195,
    MITEL_CC_MULTIMEDIA_AGENT_TIER2_STANDARD_SUBSCRIPTION: 196,
    MITEL_CC_VOICE_AGENT_TIER3_STANDARD_SUBSCRIPTION: 197,
    MITEL_CC_MULTIMEDIA_AGENT_TIER3_STANDARD_SUBSCRIPTION: 198,
    MITEL_CC_VOICE_AGENT_TIER1_PREMIUM_SUBSCRIPTION: 199,
    MITEL_CC_MULTIMEDIA_AGENT_TIER1_PREMIUM_SUBSCRIPTION: 200,
    MITEL_CC_VOICE_AGENT_TIER2_PREMIUM_SUBSCRIPTION: 201,
    MITEL_CC_MULTIMEDIA_AGENT_TIER2_PREMIUM_SUBSCRIPTION: 202,
    MITEL_CC_VOICE_AGENT_TIER3_PREMIUM_SUBSCRIPTION: 203,
    MITEL_CC_MULTIMEDIA_AGENT_TIER3_PREMIUM_SUBSCRIPTION: 204,
    MITEL_CC_VOICE_AGENT_TIER1_STANDARD_PERPETUAL: 205,
    MITEL_CC_MULTIMEDIA_AGENT_TIER1_STANDARD_PERPETUAL: 206,
    MITEL_CC_VOICE_AGENT_TIER2_STANDARD_PERPETUAL: 207,
    MITEL_CC_MULTIMEDIA_AGENT_TIER2_STANDARD_PERPETUAL: 208,
    MITEL_CC_VOICE_AGENT_TIER3_STANDARD_PERPETUAL: 209,
    MITEL_CC_MULTIMEDIA_AGENT_TIER3_STANDARD_PERPETUAL: 210,
    MITEL_CC_VOICE_AGENT_TIER1_PREMIUM_PERPETUAL: 211,
    MITEL_CC_MULTIMEDIA_AGENT_TIER1_PREMIUM_PERPETUAL: 212,
    MITEL_CC_VOICE_AGENT_TIER2_PREMIUM_PERPETUAL: 213,
    MITEL_CC_MULTIMEDIA_AGENT_TIER2_PREMIUM_PERPETUAL: 214,
    MITEL_CC_VOICE_AGENT_TIER3_PREMIUM_PERPETUAL: 215,
    MITEL_CC_MULTIMEDIA_AGENT_TIER3_PREMIUM_PERPETUAL: 216,
    MITEL_MBG: 217,
    MITEL_MAILBOX: 218,
    MITEL_AWC: 219,
    MITEL_SRCPORTS: 220,
    MITEL_IVRPORTS: 221,
    AVAYA_CALL_RECORDING_TIER1: 222,
    AVAYA_CALL_RECORDING_TIER2: 223,
    AVAYA_CALL_RECORDING_TIER3: 224,
    CXNOW_VOICE_ONLY_USER: 225,
    CXNOW_DIGITAL_ONLY_USER: 226,
    CXNOW_AGENT_SIP: 227,
    CXNOW_NAILEDUP_SIP: 228,
    SIP_ACTIVE_36_DO_NOT_USE: 229,
    SIP_STANDBY_36_DO_NOT_USE: 230,
    CXNOW_SBC_PORT_CHARGE: 231,
    CXNOW_AT_ASSET: 269,
    CXNOW_START_AUTOTASK: 270,
    CXNOW_DIGITAL_AUTOTASK: 271,
    MITEL_TELEWORKER: 272,
    SIP_GAMMA_MINS_LAND_MOB: 273,
    SIP_GAMMA_STCM_DDI_INCE_1_1K: 275,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K: 276,
    TTB_SIP_ACTIVE_12: 277,
    TTB_SIP_ACTIVE_36: 278,
    CALLMEDIA_VOICE_PERPETUAL: 279,
    CALLMEDIA_MULTI_CHANNEL_PERPETUAL: 280,
    CALLMEDIA_OUTBOUND_PERPETUAL: 281,
    TEAMS_SUBSCRIPTION_TIER1: 282,
    TEAMS_SUBSCRIPTION_TIER2: 283,
    TEAMS_SIP_ACTIVE_12: 284,
    TEAMS_SIP_STANDBY_12: 285,
    TEAMS_SIP_ACTIVE_36: 286,
    TEAMS_SIP_STANDBY_36: 287,
    CXNOW_TALKATIVE_PLATFORM: 288,
    CXNOW_TALKATIVE_COMMITTED: 289,
    PHONEPLUS_MONTH_ROLLING: 290,
    PHONEPLUS_1YEAR_DO_NOT_USE: 291,
    PHONEPLUS_3YEAR_DO_NOT_USE: 292,
    CXNOW_SIP_ACTIVE_36: 293,
    CXNOW_SIP_STANDBY_36: 294,
    SIP_MIGRATION: 295,
    CXNOW_RING_CENTRAL: 296,
    GENESYS_COMMUNICATE_ANNUALPREPAY_NAMED_DO_NOT_USE: 297,
    GENESYS_COMMUNICATE_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 298,
    GENESYS_COMMUNICATE_ANNUALPREPAY_HOURLY_DO_NOT_USE: 299,
    GENESYS_COMMUNICATE_ANNUALM2M_NAMED_DO_NOT_USE: 300,
    GENESYS_COMMUNICATE_ANNUALM2M_CONCURRENT_DO_NOT_USE: 301,
    GENESYS_COMMUNICATE_ANNUALM2M_HOURLY_DO_NOT_USE: 302,
    GENESYS_COMMUNICATE_M2M_NAMED_DO_NOT_USE: 303,
    GENESYS_COMMUNICATE_M2M_CONCURRENT_DO_NOT_USE: 304,
    GENESYS_COMMUNICATE_M2M_HOURLY_DO_NOT_USE: 305,
    GENESYS_PURECLOUD1_ANNUALPREPAY_NAMED_DO_NOT_USE: 306,
    GENESYS_PURECLOUD1_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 307,
    GENESYS_PURECLOUD1_ANNUALPREPAY_HOURLY_DO_NOT_USE: 308,
    GENESYS_PURECLOUD1_ANNUALM2M_NAMED_DO_NOT_USE: 309,
    GENESYS_PURECLOUD1_ANNUALM2M_CONCURRENT_DO_NOT_USE: 310,
    GENESYS_PURECLOUD1_ANNUALM2M_HOURLY_DO_NOT_USE: 311,
    GENESYS_PURECLOUD1_M2M_NAMED_DO_NOT_USE: 312,
    GENESYS_PURECLOUD1_M2M_CONCURRENT_DO_NOT_USE: 313,
    GENESYS_PURECLOUD1_M2M_HOURLY_DO_NOT_USE: 314,
    GENESYS_PURECLOUD2_ANNUALPREPAY_NAMED_DO_NOT_USE: 315,
    GENESYS_PURECLOUD2_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 316,
    GENESYS_PURECLOUD2_ANNUALPREPAY_HOURLY_DO_NOT_USE: 317,
    GENESYS_PURECLOUD2_ANNUALM2M_NAMED_DO_NOT_USE: 318,
    GENESYS_PURECLOUD2_ANNUALM2M_CONCURRENT_DO_NOT_USE: 319,
    GENESYS_PURECLOUD2_ANNUALM2M_HOURLY_DO_NOT_USE: 320,
    GENESYS_PURECLOUD2_M2M_NAMED_DO_NOT_USE: 321,
    GENESYS_PURECLOUD2_M2M_CONCURRENT_DO_NOT_USE: 322,
    GENESYS_PURECLOUD2_M2M_HOURLY_DO_NOT_USE: 323,
    GENESYS_PURECLOUD3_ANNUALPREPAY_NAMED_DO_NOT_USE: 324,
    GENESYS_PURECLOUD3_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 325,
    GENESYS_PURECLOUD3_ANNUALPREPAY_HOURLY_DO_NOT_USE: 326,
    GENESYS_PURECLOUD3_ANNUALM2M_NAMED_DO_NOT_USE: 327,
    GENESYS_PURECLOUD3_ANNUALM2M_CONCURRENT_DO_NOT_USE: 328,
    GENESYS_PURECLOUD3_ANNUALM2M_HOURLY_DO_NOT_USE: 329,
    GENESYS_PURECLOUD3_M2M_NAMED_DO_NOT_USE: 330,
    GENESYS_PURECLOUD3_M2M_CONCURRENT_DO_NOT_USE: 331,
    GENESYS_PURECLOUD3_M2M_HOURLY_DO_NOT_USE: 332,
    GENESYS_MSTEAMS_ANNUALPREPAY_NAMED_DO_NOT_USE: 333,
    GENESYS_MSTEAMS_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 334,
    GENESYS_MSTEAMS_ANNUALM2M_NAMED_DO_NOT_USE: 335,
    GENESYS_MSTEAMS_ANNUALM2M_CONCURRENT_DO_NOT_USE: 336,
    GENESYS_ZOOM_INT_ANNUALPREPAY_NAMED_DO_NOT_USE: 337,
    GENESYS_ZOOM_INT_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 338,
    GENESYS_ZOOM_INT_ANNUALM2M_NAMED_DO_NOT_USE: 339,
    GENESYS_ZOOM_INT_ANNUALM2M_CONCURRENT_DO_NOT_USE: 340,
    GENESYS_PURECLOUD_WALLBOARD_ANNUALPREPAY_DO_NOT_USE: 341,
    GENESYS_PURECLOUD_WALLBOARD_ANNUALM2M_DO_NOT_USE: 342,
    GENESYS_170_NV_USR1WEMII_ANNUALPREPAY_NAMED_DO_NOT_USE: 343,
    GENESYS_170_NV_USR1WEMIIC_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 344,
    GENESYS_170_NV_USR1WEMII_ANNUALM2M_NAMED_DO_NOT_USE: 345,
    GENESYS_170_NV_USR1WEMIIC_ANNUALM2M_CONCURRENT_DO_NOT_USE: 346,
    GENESYS_170_NV_USR1WEMII_M2M_NAMED_DO_NOT_USE: 347,
    GENESYS_170_NV_USR1WEMIIC_M2M_CONCURRENT_DO_NOT_USE: 348,
    GENESYS_170_NV_USR1WEMI_ANNUALPREPAY_NAMED_DO_NOT_USE: 349,
    GENESYS_170_NV_USR1WEMIC_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 350,
    GENESYS_170_NV_USR1WEMI_ANNUALM2M_NAMED_DO_NOT_USE: 351,
    GENESYS_170_NV_USR1WEMIC_ANNUALM2M_CONCURRENT_DO_NOT_USE: 352,
    GENESYS_170_NV_USR1WEMI_M2M_NAMED_DO_NOT_USE: 353,
    GENESYS_170_NV_USR1WEMIC_M2M_CONCURRENT_DO_NOT_USE: 354,
    GENESYS_PC_170_NV_USR1DIGI_ANNUALPREPAY_NAMED_DO_NOT_USE: 355,
    GENESYS_PC_170_NV_USR1DIGIC_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 356,
    GENESYS_PC_170_NV_USR1DIGI_ANNUALM2M_NAMED_DO_NOT_USE: 357,
    GENESYS_PC_170_NV_USR1DIGIC_ANNUALM2M_CONCURRENT_DO_NOT_USE: 358,
    GENESYS_PC_170_NV_USR1DIGI_M2M_NAMED_DO_NOT_USE: 359,
    GENESYS_PC_170_NV_USR1DIGIC_M2M_CONCURRENT_DO_NOT_USE: 360,
    GENESYS_PC_170_NV_USR1DIGII_ANNUALPREPAY_NAMED_DO_NOT_USE: 361,
    GENESYS_PC_170_NV_USR1DIGIIC_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 362,
    GENESYS_PC_170_NV_USR1DIGII_ANNUALM2M_NAMED_DO_NOT_USE: 363,
    GENESYS_PC_170_NV_USR1DIGIIC_ANNUALM2M_CONCURRENT_DO_NOT_USE: 364,
    GENESYS_PC_170_NV_USR1DIGII_M2M_NAMED_DO_NOT_USE: 365,
    GENESYS_PC_170_NV_USR1DIGIIC_M2M_CONCURRENT_DO_NOT_USE: 366,
    GENESYS_PC_170_NV_USR2DIGI_ANNUALPREPAY_NAMED_DO_NOT_USE: 367,
    GENESYS_PC_170_NV_USR2DIGIC_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 368,
    GENESYS_PC_170_NV_USR2DIGI_ANNUALM2M_NAMED_DO_NOT_USE: 369,
    GENESYS_PC_170_NV_USR2DIGIC_ANNUALM2M_CONCURRENT_DO_NOT_USE: 370,
    GENESYS_PC_170_NV_USR2DIGI_M2M_NAMED_DO_NOT_USE: 371,
    GENESYS_PC_170_NV_USR2DIGIC_M2M_CONCURRENT_DO_NOT_USE: 372,
    GENESYS_PC_170_NV_PCSFAN_ANNUALPREPAY_NAMED_DO_NOT_USE: 373,
    GENESYS_PC_170_NV_PCSFANC_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 374,
    GENESYS_PC_170_NV_PCSFAN_ANNUALM2M_NAMED_DO_NOT_USE: 375,
    GENESYS_PC_170_NV_PCSFANC_ANNUALM2M_CONCURRENT_DO_NOT_USE: 376,
    GENESYS_PC_170_NV_PCSFAN_M2M_NAMED_DO_NOT_USE: 377,
    GENESYS_PC_170_NV_PCSFANC_M2M_CONCURRENT_DO_NOT_USE: 378,
    GENESYS_PC_170_NV_PCSFCAN_ANNUALPREPAY_NAMED_DO_NOT_USE: 379,
    GENESYS_PC_170_NV_PCSFCAN_ANNUALM2M_NAMED_DO_NOT_USE: 380,
    GENESYS_PC_170_NV_PCSFCAN_M2M_NAMED_DO_NOT_USE: 381,
    TEAMS_REC_SMART: 382,
    TEAMS_REC_SMART_200: 383,
    TEAMS_REC_SMART_1000: 384,
    TEAMS_REC_SMART_2500: 385,
    TEAMS_REC_UC: 386,
    TEAMS_REC_UC_200: 387,
    TEAMS_REC_UC_1000: 388,
    TEAMS_REC_UC_2500: 389,
    TEAMS_REC_COMP: 390,
    TEAMS_REC_COMP_200: 391,
    TEAMS_REC_COMP_1000: 392,
    TEAMS_REC_COMP_2500: 393,
    TEAMS_REC_COMP_UC: 394,
    TEAMS_REC_COMP_UC_200: 395,
    TEAMS_REC_COMP_UC_1000: 396,
    TEAMS_REC_COMP_UC_2500: 397,
    TEAMS_REC_ADDON_ANALYTICS: 398,
    TEAMS_REC_STORAGE_500GB_LRS: 399,
    TEAMS_REC_STORAGE_500GB_GRS: 400,
    TEAMS_REC_ARCH_STORAGE_500GB_LRS: 401,
    TEAMS_REC_ARCH_STORAGE_500GB_GRS: 402,
    TEAMS_REC_TRANSCRIPTION_100H: 403,
    TEAMS_REC_TRANSLATE_100H: 404,
    TEAMS_REC_DATA_EXPORT_PUB: 405,
    TEAMS_REC_DATA_EXPORT_AZURE: 406,
    SIP_ACTIVE_SEMA: 407,
    SIP_STANDBY_SEMA: 408,
    CXNOW_WHATSAPP_BASE: 409,
    CXNOW_WHATSAPP_ADD_500: 410,
    PHONEPLUS_1YEAR_DISCOUNT_DO_NOT_USE: 411,
    PHONEPLUS_3YEAR_DISCOUNT_DO_NOT_USE: 412,
    TEAMS_SUBSCRIPTION_USER_5USERSPERCHANNEL_TIER1: 413,
    TEAMS_SUBSCRIPTION_USER_5USERSPERCHANNEL_TIER2: 414,
    GENESYS_TEAMS_SUBSCRIPTION_USER_5USERSPERCHANNEL_TIER1: 415,
    GENESYS_TEAMS_SUBSCRIPTION_USER_5USERSPERCHANNEL_TIER2: 416,
    RINGCENTRAL_UC_BASIC_USER_DO_NOT_USE: 417,
    RINGCENTRAL_UC_ENTRY_USER_DO_NOT_USE: 418,
    RINGCENTRAL_UC_STANDARD_USER_ANNUAL_TIER1_DO_NOT_USE: 419,
    RINGCENTRAL_UC_PREMIUM_USER_ANNUAL_TIER1_DO_NOT_USE: 420,
    RINGCENTRAL_UC_ULTIMATE_USER_ANNUAL_TIER1_DO_NOT_USE: 421,
    RINGCENTRAL_UC_STANDARD_USER_ANNUAL_TIER2_DO_NOT_USE: 422,
    RINGCENTRAL_UC_PREMIUM_USER_ANNUAL_TIER2_DO_NOT_USE: 423,
    RINGCENTRAL_UC_ULTIMATE_USER_ANNUAL_TIER2_DO_NOT_USE: 424,
    RINGCENTRAL_UC_STANDARD_USER_ANNUAL_TIER3_DO_NOT_USE: 425,
    RINGCENTRAL_UC_PREMIUM_USER_ANNUAL_TIER3_DO_NOT_USE: 426,
    RINGCENTRAL_UC_ULTIMATE_USER_ANNUAL_TIER3_DO_NOT_USE: 427,
    RINGCENTRAL_UC_STANDARD_USER_MONTHLY_TIER1_DO_NOT_USE: 428,
    RINGCENTRAL_UC_PREMIUM_USER_MONTHLY_TIER1_DO_NOT_USE: 429,
    RINGCENTRAL_UC_ULTIMATE_USER_MONTHLY_TIER1_DO_NOT_USE: 430,
    RINGCENTRAL_UC_STANDARD_USER_MONTHLY_TIER2_DO_NOT_USE: 431,
    RINGCENTRAL_UC_PREMIUM_USER_MONTHLY_TIER2_DO_NOT_USE: 432,
    RINGCENTRAL_UC_ULTIMATE_USER_MONTHLY_TIER2_DO_NOT_USE: 433,
    RINGCENTRAL_UC_STANDARD_USER_MONTHLY_TIER3_DO_NOT_USE: 434,
    RINGCENTRAL_UC_PREMIUM_USER_MONTHLY_TIER3_DO_NOT_USE: 435,
    RINGCENTRAL_UC_ULTIMATE_USER_MONTHLY_TIER3_DO_NOT_USE: 436,
    RINGCENTRAL_UC_CXNOW_INT_DO_NOT_USE: 437,
    RINGCENTRAL_UC_LIVE_REPORTS_DO_NOT_USE: 438,
    RINGCENTRAL_UC_INVIEW_MGT_DO_NOT_USE: 439,
    RINGCENTRAL_UC_ADD_NUMBER_DO_NOT_USE: 440,
    RINGCENTRAL_UC_MSFT_DYNAMICS_DO_NOT_USE: 441,
    RINGCENTRAL_CC_DIGITAL_AGENT_DO_NOT_USE: 442,
    RINGCENTRAL_CC_ESSENTIALS_AGENT_DO_NOT_USE: 443,
    RINGCENTRAL_CC_STANDARD_AGENT_DO_NOT_USE: 444,
    RINGCENTRAL_CC_SURVEY_MNGR_DO_NOT_USE: 445,
    RINGCENTRAL_CC_WORKFORCE_MGT_PRO_DO_NOT_USE: 446,
    RINGCENTRAL_CC_QUALITY_MGT_PRO_DO_NOT_USE: 447,
    RINGCENTRAL_CC_SCREEN_REC_PRO_DO_NOT_USE: 448,
    RINGCENTRAL_CC_QTY_MGT_ANLY_PRO_DO_NOT_USE: 449,
    RINGCENTRAL_CC_OMNI_ANLY_PRO_DO_NOT_USE: 450,
    RINGCENTRAL_CC_SF_AGT_DO_NOT_USE: 451,
    RINGCENTRAL_CC_ZEN_AGENT_DO_NOT_USE: 452,
    CXNOW_SIP_ACTIVE_12: 453,
    CXNOW_SIP_STANDBY_12: 454,
    RINGCENTRAL_CC_PREMIUM_AGENT_DO_NOT_USE: 455,
    RINGCENTRAL_CC_ULTIMATE_AGENT_DO_NOT_USE: 456,
    RINGCENTRAL_CC_UNLIMITED_AGENT_DO_NOT_USE: 457,
    TEAMS_SUBSCRIPTION_USER_3USERSPERCHANNEL_TIER1: 458,
    TEAMS_SUBSCRIPTION_USER_7USERSPERCHANNEL_TIER1: 459,
    TEAMS_SUBSCRIPTION_USER_10USERSPERCHANNEL_TIER1: 460,
    TEAMS_SUBSCRIPTION_USER_3USERSPERCHANNEL_TIER2: 461,
    TEAMS_SUBSCRIPTION_USER_7USERSPERCHANNEL_TIER2: 462,
    TEAMS_SUBSCRIPTION_USER_10USERSPERCHANNEL_TIER2: 463,
    TEAMS_ADDITIONAL_SIP_ACTIVE_12: 464,
    TEAMS_ADDITIONAL_SIP_STANDBY_12: 465,
    TEAMS_ADDITIONAL_SIP_ACTIVE_36: 466,
    TEAMS_ADDITIONAL_SIP_STANDBY_36: 467,
    CXNOW_ADVANCED_USER: 468,
    CXNOW_BASE_PACKAGE: 469,
    SP_GAMMA_IP_HC_GAMMA_SIP: 470,
    SP_GAMMA_IP_DC_GAMMA_SIP: 471,
    MITEL_ASC_Essentials: 472,
    MITEL_ASC_Premier: 473,
    MITEL_ASC_Elite: 474,
    GENESYS_DIGITAL_2_ANNUALPREPAY_NAMED_DO_NOT_USE: 476,
    GENESYS_DIGITAL_2_ANNUALM2M_NAMED_DO_NOT_USE: 477,
    GENESYS_DIGITAL_2_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 478,
    GENESYS_DIGITAL_2_ANNUALM2M_CONCURRENT_DO_NOT_USE: 479,
    GENESYS_DIGITAL_3_ANNUALPREPAY_NAMED_DO_NOT_USE: 480,
    GENESYS_DIGITAL_3_ANNUALM2M_NAMED_DO_NOT_USE: 481,
    GENESYS_DIGITAL_3_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 482,
    GENESYS_DIGITAL_3_ANNUALM2M_CONCURRENT_DO_NOT_USE: 483,
    GENESYS_CX_AI_EXPERIENCE_FOR_DIGITAL_ANNUALPREPAY_NAMED_DO_NOT_USE: 484,
    GENESYS_CX_AI_EXPERIENCE_FOR_DIGITAL_ANNUALM2M_NAMED_DO_NOT_USE: 485,
    GENESYS_CX_AI_EXPERIENCE_FOR_DIGITAL_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 486,
    GENESYS_CX_AI_EXPERIENCE_FOR_DIGITAL_ANNUALM2M_CONCURRENT_DO_NOT_USE: 487,
    GENESYS_CX_AI_EXPERIENCE_ANNUALPREPAY_NAMED_DO_NOT_USE: 488,
    GENESYS_CX_AI_EXPERIENCE_ANNUALM2M_NAMED_DO_NOT_USE: 489,
    GENESYS_CX_AI_EXPERIENCE_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 490,
    GENESYS_CX_AI_EXPERIENCE_ANNUALM2M_CONCURRENT_DO_NOT_USE: 491,
    GENESYS_170_NV_USR2WEMI_ANNUALPREPAY_NAMED_DO_NOT_USE: 492,
    GENESYS_170_NV_USR2WEMI_ANNUALM2M_NAMED_DO_NOT_USE: 493,
    GENESYS_170_NV_USR2WEMIC_ANNUALPREPAY_CONCURRENT_DO_NOT_USE: 494,
    GENESYS_170_NV_USR2WEMIC_ANNUALM2M_CONCURRENT_DO_NOT_USE: 495,
    AURA_ASC_RECORDING_LICENSES: 496,
    AURA_ASC_QUALITY_MONITORING: 497,
    AURA_ASC_SPEECH_ANALYTICS_KEYWORD_SPOTTING: 498,
    AURA_ASC_SPEECH_ANALYTICS_TRANSCRIPTION: 499,
    AURA_ASC_SPEECH_ANALYTICS_ENGINE_ENABLING: 500,
    AURA_ASC_CONNECT_FOR_SALESFORCE: 501,
    AURA_ASC_CONTACT_CENTRE_INTEGRATION: 502,
    SYCURIO_ESSENTIALS_USER_TIER1_1YR: 503,
    SYCURIO_ESSENTIALS_USER_TIER2_1YR: 504,
    SYCURIO_ESSENTIALS_USER_TIER3_1YR: 505,
    SYCURIO_ESSENTIALS_USER_TIER4_1YR: 506,
    SYCURIO_ESSENTIALS_USER_TIER1_3YR: 507,
    SYCURIO_ESSENTIALS_USER_TIER2_3YR: 508,
    SYCURIO_ESSENTIALS_USER_TIER3_3YR: 509,
    SYCURIO_ESSENTIALS_USER_TIER4_3YR: 510,
    SYCURIO_ESSENTIALS_USER_TIER1_5YR: 511,
    SYCURIO_ESSENTIALS_USER_TIER2_5YR: 512,
    SYCURIO_ESSENTIALS_USER_TIER3_5YR: 513,
    SYCURIO_ESSENTIALS_USER_TIER4_5YR: 514,
    GENESYS_TEAMS_SUBSCRIPTION_USER_1USERPERCHANNEL_TIER1: 515,
    GENESYS_TEAMS_SUBSCRIPTION_USER_1USERPERCHANNEL_TIER2: 516,
    GENESYS_TEAMS_SUBSCRIPTION_USER_3USERSPERCHANNEL_TIER1: 517,
    GENESYS_TEAMS_SUBSCRIPTION_USER_3USERSPERCHANNEL_TIER2: 518,
    GENESYS_TEAMS_SUBSCRIPTION_USER_1_2_USERSPERCHANNEL_TIER1: 519,
    GENESYS_TEAMS_SUBSCRIPTION_USER_1_2_USERSPERCHANNEL_TIER2: 520,
    GENESYS_TEAMS_SUBSCRIPTION_USER_7USERSPERCHANNEL_TIER1: 521,
    GENESYS_TEAMS_SUBSCRIPTION_USER_7USERSPERCHANNEL_TIER2: 522,
    GENESYS_TEAMS_SUBSCRIPTION_USER_10USERSPERCHANNEL_TIER1: 523,
    GENESYS_TEAMS_SUBSCRIPTION_USER_10USERSPERCHANNEL_TIER2: 524,
    UC_ANALYTICS_FOUNDATION_USER: 525,
    UC_ANALYTICS_ESSENTIALS_USER_DO_NOT_USE: 526,
    UC_ANALYTICS_PLUS_USER_DO_NOT_USE: 527,
    UC_ANALYTICS_TAILORED_USER: 528,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_1YR_20_99_USERS: 529, // Avaya Axp Profiles
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_1YR_100_199_USERS: 530,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_1YR_200_399_USERS: 531,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_1YR_400_USERS: 532,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_3YR_20_99_USERS: 533,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_3YR_100_199_USERS: 534,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_3YR_200_399_USERS: 535,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_3YR_400_USERS: 536,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_5YR_20_99_USERS: 537,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_5YR_100_199_USERS: 538,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_5YR_200_399_USERS: 539,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_5YR_400_USERS: 540,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_1YR_20_99_USERS: 541,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_1YR_100_199_USERS: 542,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_1YR_200_399_USERS: 543,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_1YR_400_USERS: 544,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_3YR_20_99_USERS: 545,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_3YR_100_199_USERS: 546,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_3YR_200_399_USERS: 547,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_3YR_400_USERS: 548,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_5YR_20_99_USERS: 549,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_5YR_100_199_USERS: 550,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_5YR_200_399_USERS: 551,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_5YR_400_USERS: 552,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_1YR_20_99_USERS: 553,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_1YR_100_199_USERS: 554,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_1YR_200_399_USERS: 555,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_1YR_400_USERS: 556,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_3YR_20_99_USERS: 557,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_3YR_100_199_USERS: 558,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_3YR_200_399_USERS: 559,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_3YR_400_USERS: 560,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_5YR_20_99_USERS: 561,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_5YR_100_199_USERS: 562,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_5YR_200_399_USERS: 563,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_5YR_400_USERS: 564,
    AVAYA_AXP_CONNECT_VOICE_BUNDLE_1YR_20_99_USERS: 565,
    AVAYA_AXP_CONNECT_VOICE_BUNDLE_1YR_100_199_USERS: 566,
    AVAYA_AXP_CONNECT_VOICE_BUNDLE_1YR_200_399_USERS: 567,
    AVAYA_AXP_CONNECT_VOICE_BUNDLE_1YR_400_USERS: 568,
    AVAYA_AXP_CONNECT_VOICE_BUNDLE_3YR_20_99_USERS: 569,
    AVAYA_AXP_CONNECT_VOICE_BUNDLE_3YR_100_199_USERS: 570,
    AVAYA_AXP_CONNECT_VOICE_BUNDLE_3YR_200_399_USERS: 571,
    AVAYA_AXP_CONNECT_VOICE_BUNDLE_3YR_400_USERS: 572,
    AVAYA_AXP_CONNECT_VOICE_BUNDLE_5YR_20_99_USERS: 573,
    AVAYA_AXP_CONNECT_VOICE_BUNDLE_5YR_100_199_USERS: 574,
    AVAYA_AXP_CONNECT_VOICE_BUNDLE_5YR_200_399_USERS: 575,
    AVAYA_AXP_CONNECT_VOICE_BUNDLE_5YR_400_USERS: 576,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_1YR_20_99_USERS: 577, // Avaya Axp AddOns
    AVAYA_AXP_WORKFORCE_MANAGEMENT_1YR_100_199_USERS: 578,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_1YR_200_399_USERS: 579,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_1YR_400_USERS: 580,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_3YR_20_99_USERS: 581,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_3YR_100_199_USERS: 582,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_3YR_200_399_USERS: 583,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_3YR_400_USERS: 584,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_5YR_20_99_USERS: 585,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_5YR_100_199_USERS: 586,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_5YR_200_399_USERS: 587,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_5YR_400_USERS: 588,
    AVAYA_AXP_SCREEN_RECORDING_1YR_20_99_USERS: 589,
    AVAYA_AXP_SCREEN_RECORDING_1YR_100_199_USERS: 590,
    AVAYA_AXP_SCREEN_RECORDING_1YR_200_399_USERS: 591,
    AVAYA_AXP_SCREEN_RECORDING_1YR_400_USERS: 592,
    AVAYA_AXP_SCREEN_RECORDING_3YR_20_99_USERS: 593,
    AVAYA_AXP_SCREEN_RECORDING_3YR_100_199_USERS: 594,
    AVAYA_AXP_SCREEN_RECORDING_3YR_200_399_USERS: 595,
    AVAYA_AXP_SCREEN_RECORDING_3YR_400_USERS: 596,
    AVAYA_AXP_SCREEN_RECORDING_5YR_20_99_USERS: 597,
    AVAYA_AXP_SCREEN_RECORDING_5YR_100_199_USERS: 598,
    AVAYA_AXP_SCREEN_RECORDING_5YR_200_399_USERS: 599,
    AVAYA_AXP_SCREEN_RECORDING_5YR_400_USERS: 600,
    AVAYA_AXP_QUALITY_MANAGEMENT_1YR_20_99_USERS: 601,
    AVAYA_AXP_QUALITY_MANAGEMENT_1YR_100_199_USERS: 602,
    AVAYA_AXP_QUALITY_MANAGEMENT_1YR_200_399_USERS: 603,
    AVAYA_AXP_QUALITY_MANAGEMENT_1YR_400_USERS: 604,
    AVAYA_AXP_QUALITY_MANAGEMENT_3YR_20_99_USERS: 605,
    AVAYA_AXP_QUALITY_MANAGEMENT_3YR_100_199_USERS: 606,
    AVAYA_AXP_QUALITY_MANAGEMENT_3YR_200_399_USERS: 607,
    AVAYA_AXP_QUALITY_MANAGEMENT_3YR_400_USERS: 608,
    AVAYA_AXP_QUALITY_MANAGEMENT_5YR_20_99_USERS: 609,
    AVAYA_AXP_QUALITY_MANAGEMENT_5YR_100_199_USERS: 610,
    AVAYA_AXP_QUALITY_MANAGEMENT_5YR_200_399_USERS: 611,
    AVAYA_AXP_QUALITY_MANAGEMENT_5YR_400_USERS: 612,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_1YR_20_99_USERS: 613,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_1YR_100_199_USERS: 614,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_1YR_200_399_USERS: 615,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_1YR_400_USERS: 616,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_3YR_20_99_USERS: 617,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_3YR_100_199_USERS: 618,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_3YR_200_399_USERS: 619,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_3YR_400_USERS: 620,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_5YR_20_99_USERS: 621,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_5YR_100_199_USERS: 622,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_5YR_200_399_USERS: 623,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_5YR_400_USERS: 624,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_EACH_ADDITIONAL_LANGUAGE_1YR_20_99_USERS: 625,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_EACH_ADDITIONAL_LANGUAGE_1YR_100_199_USERS: 626,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_EACH_ADDITIONAL_LANGUAGE_1YR_200_399_USERS: 627,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_EACH_ADDITIONAL_LANGUAGE_1YR_400_USERS: 628,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_EACH_ADDITIONAL_LANGUAGE_3YR_20_99_USERS: 629,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_EACH_ADDITIONAL_LANGUAGE_3YR_100_199_USERS: 630,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_EACH_ADDITIONAL_LANGUAGE_3YR_200_399_USERS: 631,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_EACH_ADDITIONAL_LANGUAGE_3YR_400_USERS: 632,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_EACH_ADDITIONAL_LANGUAGE_5YR_20_99_USERS: 633,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_EACH_ADDITIONAL_LANGUAGE_5YR_100_199_USERS: 634,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_EACH_ADDITIONAL_LANGUAGE_5YR_200_399_USERS: 635,
    AVAYA_AXP_AUTOMATED_QUALITY_MANAGEMENT_EACH_ADDITIONAL_LANGUAGE_5YR_400_USERS: 636,
    AVAYA_AXP_SPEECH_ANALYTICS_BATCH_1YR_20_99_USERS: 637,
    AVAYA_AXP_SPEECH_ANALYTICS_BATCH_1YR_100_199_USERS: 638,
    AVAYA_AXP_SPEECH_ANALYTICS_BATCH_1YR_200_399_USERS: 639,
    AVAYA_AXP_SPEECH_ANALYTICS_BATCH_1YR_400_USERS: 640,
    AVAYA_AXP_SPEECH_ANALYTICS_BATCH_3YR_20_99_USERS: 641,
    AVAYA_AXP_SPEECH_ANALYTICS_BATCH_3YR_100_199_USERS: 642,
    AVAYA_AXP_SPEECH_ANALYTICS_BATCH_3YR_200_399_USERS: 643,
    AVAYA_AXP_SPEECH_ANALYTICS_BATCH_3YR_400_USERS: 644,
    AVAYA_AXP_SPEECH_ANALYTICS_BATCH_5YR_20_99_USERS: 645,
    AVAYA_AXP_SPEECH_ANALYTICS_BATCH_5YR_100_199_USERS: 646,
    AVAYA_AXP_SPEECH_ANALYTICS_BATCH_5YR_200_399_USERS: 647,
    AVAYA_AXP_SPEECH_ANALYTICS_BATCH_5YR_400_USERS: 648,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LANGUAGE_1YR_20_99_USERS: 649,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LANGUAGE_1YR_100_199_USERS: 650,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LANGUAGE_1YR_200_399_USERS: 651,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LANGUAGE_1YR_400_USERS: 652,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LANGUAGE_3YR_20_99_USERS: 653,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LANGUAGE_3YR_100_199_USERS: 654,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LANGUAGE_3YR_200_399_USERS: 655,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LANGUAGE_3YR_400_USERS: 656,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LANGUAGE_5YR_20_99_USERS: 657,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LANGUAGE_5YR_100_199_USERS: 658,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LANGUAGE_5YR_200_399_USERS: 659,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LANGUAGE_5YR_400_USERS: 660,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LINE_OF_BUSINESS_1YR_20_99_USERS: 661,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LINE_OF_BUSINESS_1YR_100_199_USERS: 662,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LINE_OF_BUSINESS_1YR_200_399_USERS: 663,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LINE_OF_BUSINESS_1YR_400_USERS: 664,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LINE_OF_BUSINESS_3YR_20_99_USERS: 665,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LINE_OF_BUSINESS_3YR_100_199_USERS: 666,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LINE_OF_BUSINESS_3YR_200_399_USERS: 667,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LINE_OF_BUSINESS_3YR_400_USERS: 668,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LINE_OF_BUSINESS_5YR_20_99_USERS: 669,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LINE_OF_BUSINESS_5YR_100_199_USERS: 670,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LINE_OF_BUSINESS_5YR_200_399_USERS: 671,
    AVAYA_AXP_SPEECH_ANALYTICS_EACH_ADDITIONAL_LINE_OF_BUSINESS_5YR_400_USERS: 672,
    AVAYA_AXP_STRATEGIC_DESKTOP_ANALYTICS_1YR_20_99_USERS: 673,
    AVAYA_AXP_STRATEGIC_DESKTOP_ANALYTICS_1YR_100_199_USERS: 674,
    AVAYA_AXP_STRATEGIC_DESKTOP_ANALYTICS_1YR_200_399_USERS: 675,
    AVAYA_AXP_STRATEGIC_DESKTOP_ANALYTICS_1YR_400_USERS: 676,
    AVAYA_AXP_STRATEGIC_DESKTOP_ANALYTICS_3YR_20_99_USERS: 677,
    AVAYA_AXP_STRATEGIC_DESKTOP_ANALYTICS_3YR_100_199_USERS: 678,
    AVAYA_AXP_STRATEGIC_DESKTOP_ANALYTICS_3YR_200_399_USERS: 679,
    AVAYA_AXP_STRATEGIC_DESKTOP_ANALYTICS_3YR_400_USERS: 680,
    AVAYA_AXP_STRATEGIC_DESKTOP_ANALYTICS_5YR_20_99_USERS: 681,
    AVAYA_AXP_STRATEGIC_DESKTOP_ANALYTICS_5YR_100_199_USERS: 682,
    AVAYA_AXP_STRATEGIC_DESKTOP_ANALYTICS_5YR_200_399_USERS: 683,
    AVAYA_AXP_STRATEGIC_DESKTOP_ANALYTICS_5YR_400_USERS: 684,
    AVAYA_AXP_COMPLIANCE_TRIGGER_1YR_20_99_USERS: 685,
    AVAYA_AXP_COMPLIANCE_TRIGGER_1YR_100_199_USERS: 686,
    AVAYA_AXP_COMPLIANCE_TRIGGER_1YR_200_399_USERS: 687,
    AVAYA_AXP_COMPLIANCE_TRIGGER_1YR_400_USERS: 688,
    AVAYA_AXP_COMPLIANCE_TRIGGER_3YR_20_99_USERS: 689,
    AVAYA_AXP_COMPLIANCE_TRIGGER_3YR_100_199_USERS: 690,
    AVAYA_AXP_COMPLIANCE_TRIGGER_3YR_200_399_USERS: 691,
    AVAYA_AXP_COMPLIANCE_TRIGGER_3YR_400_USERS: 692,
    AVAYA_AXP_COMPLIANCE_TRIGGER_5YR_20_99_USERS: 693,
    AVAYA_AXP_COMPLIANCE_TRIGGER_5YR_100_199_USERS: 694,
    AVAYA_AXP_COMPLIANCE_TRIGGER_5YR_200_399_USERS: 695,
    AVAYA_AXP_COMPLIANCE_TRIGGER_5YR_400_USERS: 696,
    AVAYA_AXP_APPLICATION_VISUALIZATION_1YR_20_99_USERS: 697,
    AVAYA_AXP_APPLICATION_VISUALIZATION_1YR_100_199_USERS: 698,
    AVAYA_AXP_APPLICATION_VISUALIZATION_1YR_200_399_USERS: 699,
    AVAYA_AXP_APPLICATION_VISUALIZATION_1YR_400_USERS: 700,
    AVAYA_AXP_APPLICATION_VISUALIZATION_3YR_20_99_USERS: 701,
    AVAYA_AXP_APPLICATION_VISUALIZATION_3YR_100_199_USERS: 702,
    AVAYA_AXP_APPLICATION_VISUALIZATION_3YR_200_399_USERS: 703,
    AVAYA_AXP_APPLICATION_VISUALIZATION_3YR_400_USERS: 704,
    AVAYA_AXP_APPLICATION_VISUALIZATION_5YR_20_99_USERS: 705,
    AVAYA_AXP_APPLICATION_VISUALIZATION_5YR_100_199_USERS: 706,
    AVAYA_AXP_APPLICATION_VISUALIZATION_5YR_200_399_USERS: 707,
    AVAYA_AXP_APPLICATION_VISUALIZATION_5YR_400_USERS: 708,
    AVAYA_AXP_EACH_ADDITIONAL_1TB_STORAGE_1YR_20_99_USERS: 709,
    AVAYA_AXP_EACH_ADDITIONAL_1TB_STORAGE_1YR_100_199_USERS: 710,
    AVAYA_AXP_EACH_ADDITIONAL_1TB_STORAGE_1YR_200_399_USERS: 711,
    AVAYA_AXP_EACH_ADDITIONAL_1TB_STORAGE_1YR_400_USERS: 712,
    AVAYA_AXP_EACH_ADDITIONAL_1TB_STORAGE_3YR_20_99_USERS: 713,
    AVAYA_AXP_EACH_ADDITIONAL_1TB_STORAGE_3YR_100_199_USERS: 714,
    AVAYA_AXP_EACH_ADDITIONAL_1TB_STORAGE_3YR_200_399_USERS: 715,
    AVAYA_AXP_EACH_ADDITIONAL_1TB_STORAGE_3YR_400_USERS: 716,
    AVAYA_AXP_EACH_ADDITIONAL_1TB_STORAGE_5YR_20_99_USERS: 717,
    AVAYA_AXP_EACH_ADDITIONAL_1TB_STORAGE_5YR_100_199_USERS: 718,
    AVAYA_AXP_EACH_ADDITIONAL_1TB_STORAGE_5YR_200_399_USERS: 719,
    AVAYA_AXP_EACH_ADDITIONAL_1TB_STORAGE_5YR_400_USERS: 720,
    AVAYA_AXP_INTERACTION_DATA_EXPORT_MANAGER_1YR_20_99_USERS: 721,
    AVAYA_AXP_INTERACTION_DATA_EXPORT_MANAGER_1YR_100_199_USERS: 722,
    AVAYA_AXP_INTERACTION_DATA_EXPORT_MANAGER_1YR_200_399_USERS: 723,
    AVAYA_AXP_INTERACTION_DATA_EXPORT_MANAGER_1YR_400_USERS: 724,
    AVAYA_AXP_INTERACTION_DATA_EXPORT_MANAGER_3YR_20_99_USERS: 725,
    AVAYA_AXP_INTERACTION_DATA_EXPORT_MANAGER_3YR_100_199_USERS: 726,
    AVAYA_AXP_INTERACTION_DATA_EXPORT_MANAGER_3YR_200_399_USERS: 727,
    AVAYA_AXP_INTERACTION_DATA_EXPORT_MANAGER_3YR_400_USERS: 728,
    AVAYA_AXP_INTERACTION_DATA_EXPORT_MANAGER_5YR_20_99_USERS: 729,
    AVAYA_AXP_INTERACTION_DATA_EXPORT_MANAGER_5YR_100_199_USERS: 730,
    AVAYA_AXP_INTERACTION_DATA_EXPORT_MANAGER_5YR_200_399_USERS: 731,
    AVAYA_AXP_INTERACTION_DATA_EXPORT_MANAGER_5YR_400_USERS: 732,
    AVAYA_AXP_AXP_MESSAGING_10K_MSGS_EA_MONTH_FIXED_SUBS: 733,
    AVAYA_AXP_AXP_MESSAGING_70K_MSGS_EA_MONTH_FIXED_SUBS: 734,
    AVAYA_AXP_AXP_MESSAGING_300K_MSGS_EA_MO_FIXED_SUBS: 735,
    AVAYA_AXP_AXP_MESSAGING_1000K_MSGS_EA_MO_FIXED_SUBS: 736,
    AVAYA_AXP_TEAMS_SUBSCRIPTION_USER_5USERSPERCHANNEL_TIER1: 737,
    AVAYA_AXP_TEAMS_SUBSCRIPTION_USER_5USERSPERCHANNEL_TIER2: 738,
    AVAYA_AXP_TEAMS_SUBSCRIPTION_USER_1USERPERCHANNEL_TIER1: 739,
    AVAYA_AXP_TEAMS_SUBSCRIPTION_USER_1USERPERCHANNEL_TIER2: 740,
    AVAYA_AXP_TEAMS_SUBSCRIPTION_USER_3USERSPERCHANNEL_TIER1: 741,
    AVAYA_AXP_TEAMS_SUBSCRIPTION_USER_3USERSPERCHANNEL_TIER2: 742,
    AVAYA_AXP_TEAMS_SUBSCRIPTION_USER_1_2_USERSPERCHANNEL_TIER1: 743,
    AVAYA_AXP_TEAMS_SUBSCRIPTION_USER_1_2_USERSPERCHANNEL_TIER2: 744,
    AVAYA_AXP_TEAMS_SUBSCRIPTION_USER_7USERSPERCHANNEL_TIER1: 745,
    AVAYA_AXP_TEAMS_SUBSCRIPTION_USER_7USERSPERCHANNEL_TIER2: 746,
    AVAYA_AXP_TEAMS_SUBSCRIPTION_USER_10USERSPERCHANNEL_TIER1: 747,
    AVAYA_AXP_TEAMS_SUBSCRIPTION_USER_10USERSPERCHANNEL_TIER2: 748,
    UC_ANALYTICS_FOUNDATION_USER_QUOTE_ONLY: 749,
    UC_ANALYTICS_ESSENTIALS_USER: 750,
    UC_ANALYTICS_PLUS_USER: 751,
    PHONEPLUS_1YEAR_DISCOUNT: 752,
    PHONEPLUS_3YEAR_DISCOUNT: 753,
    PHONEPLUS_1YEAR: 754,
    PHONEPLUS_3YEAR: 755,
    GENESYS_COMMUNICATE_ANNUALPREPAY_NAMED: 756,
    GENESYS_COMMUNICATE_ANNUALPREPAY_CONCURRENT: 757,
    GENESYS_COMMUNICATE_ANNUALPREPAY_HOURLY: 758,
    GENESYS_COMMUNICATE_ANNUALM2M_NAMED: 759,
    GENESYS_COMMUNICATE_ANNUALM2M_CONCURRENT: 760,
    GENESYS_COMMUNICATE_ANNUALM2M_HOURLY: 761,
    GENESYS_COMMUNICATE_M2M_NAMED: 762,
    GENESYS_COMMUNICATE_M2M_CONCURRENT: 763,
    GENESYS_COMMUNICATE_M2M_HOURLY: 764,
    GENESYS_PURECLOUD1_ANNUALPREPAY_NAMED: 765,
    GENESYS_PURECLOUD1_ANNUALPREPAY_CONCURRENT: 766,
    GENESYS_PURECLOUD1_ANNUALPREPAY_HOURLY: 767,
    GENESYS_PURECLOUD1_ANNUALM2M_NAMED: 768,
    GENESYS_PURECLOUD1_ANNUALM2M_CONCURRENT: 769,
    GENESYS_PURECLOUD1_ANNUALM2M_HOURLY: 770,
    GENESYS_PURECLOUD1_M2M_NAMED: 771,
    GENESYS_PURECLOUD1_M2M_CONCURRENT: 772,
    GENESYS_PURECLOUD1_M2M_HOURLY: 773,
    GENESYS_PURECLOUD2_ANNUALPREPAY_NAMED: 774,
    GENESYS_PURECLOUD2_ANNUALPREPAY_CONCURRENT: 775,
    GENESYS_PURECLOUD2_ANNUALPREPAY_HOURLY: 776,
    GENESYS_PURECLOUD2_ANNUALM2M_NAMED: 777,
    GENESYS_PURECLOUD2_ANNUALM2M_CONCURRENT: 778,
    GENESYS_PURECLOUD2_ANNUALM2M_HOURLY: 779,
    GENESYS_PURECLOUD2_M2M_NAMED: 780,
    GENESYS_PURECLOUD2_M2M_CONCURRENT: 781,
    GENESYS_PURECLOUD2_M2M_HOURLY: 782,
    GENESYS_PURECLOUD3_ANNUALPREPAY_NAMED: 783,
    GENESYS_PURECLOUD3_ANNUALPREPAY_CONCURRENT: 784,
    GENESYS_PURECLOUD3_ANNUALPREPAY_HOURLY: 785,
    GENESYS_PURECLOUD3_ANNUALM2M_NAMED: 786,
    GENESYS_PURECLOUD3_ANNUALM2M_CONCURRENT: 787,
    GENESYS_PURECLOUD3_ANNUALM2M_HOURLY: 788,
    GENESYS_PURECLOUD3_M2M_NAMED: 789,
    GENESYS_PURECLOUD3_M2M_CONCURRENT: 790,
    GENESYS_PURECLOUD3_M2M_HOURLY: 791,
    GENESYS_MSTEAMS_ANNUALPREPAY_NAMED: 792,
    GENESYS_MSTEAMS_ANNUALPREPAY_CONCURRENT: 793,
    GENESYS_MSTEAMS_ANNUALM2M_NAMED: 794,
    GENESYS_MSTEAMS_ANNUALM2M_CONCURRENT: 795,
    GENESYS_ZOOM_INT_ANNUALPREPAY_NAMED: 796,
    GENESYS_ZOOM_INT_ANNUALPREPAY_CONCURRENT: 797,
    GENESYS_ZOOM_INT_ANNUALM2M_NAMED: 798,
    GENESYS_ZOOM_INT_ANNUALM2M_CONCURRENT: 799,
    GENESYS_PURECLOUD_WALLBOARD_ANNUALPREPAY: 800,
    GENESYS_PURECLOUD_WALLBOARD_ANNUALM2M: 801,
    GENESYS_170_NV_USR1WEMII_ANNUALPREPAY_NAMED: 802,
    GENESYS_170_NV_USR1WEMIIC_ANNUALPREPAY_CONCURRENT: 803,
    GENESYS_170_NV_USR1WEMII_ANNUALM2M_NAMED: 804,
    GENESYS_170_NV_USR1WEMIIC_ANNUALM2M_CONCURRENT: 805,
    GENESYS_170_NV_USR1WEMII_M2M_NAMED: 806,
    GENESYS_170_NV_USR1WEMIIC_M2M_CONCURRENT: 807,
    GENESYS_170_NV_USR1WEMI_ANNUALPREPAY_NAMED: 808,
    GENESYS_170_NV_USR1WEMIC_ANNUALPREPAY_CONCURRENT: 809,
    GENESYS_170_NV_USR1WEMI_ANNUALM2M_NAMED: 810,
    GENESYS_170_NV_USR1WEMIC_ANNUALM2M_CONCURRENT: 811,
    GENESYS_170_NV_USR1WEMI_M2M_NAMED: 812,
    GENESYS_170_NV_USR1WEMIC_M2M_CONCURRENT: 813,
    GENESYS_PC_170_NV_USR1DIGI_ANNUALPREPAY_NAMED: 814,
    GENESYS_PC_170_NV_USR1DIGIC_ANNUALPREPAY_CONCURRENT: 815,
    GENESYS_PC_170_NV_USR1DIGI_ANNUALM2M_NAMED: 816,
    GENESYS_PC_170_NV_USR1DIGIC_ANNUALM2M_CONCURRENT: 817,
    GENESYS_PC_170_NV_USR1DIGI_M2M_NAMED: 818,
    GENESYS_PC_170_NV_USR1DIGIC_M2M_CONCURRENT: 819,
    GENESYS_PC_170_NV_USR1DIGII_ANNUALPREPAY_NAMED: 820,
    GENESYS_PC_170_NV_USR1DIGIIC_ANNUALPREPAY_CONCURRENT: 821,
    GENESYS_PC_170_NV_USR1DIGII_ANNUALM2M_NAMED: 822,
    GENESYS_PC_170_NV_USR1DIGIIC_ANNUALM2M_CONCURRENT: 823,
    GENESYS_PC_170_NV_USR1DIGII_M2M_NAMED: 824,
    GENESYS_PC_170_NV_USR1DIGIIC_M2M_CONCURRENT: 825,
    GENESYS_PC_170_NV_USR2DIGI_ANNUALPREPAY_NAMED: 826,
    GENESYS_PC_170_NV_USR2DIGIC_ANNUALPREPAY_CONCURRENT: 827,
    GENESYS_PC_170_NV_USR2DIGI_ANNUALM2M_NAMED: 828,
    GENESYS_PC_170_NV_USR2DIGIC_ANNUALM2M_CONCURRENT: 829,
    GENESYS_PC_170_NV_USR2DIGI_M2M_NAMED: 830,
    GENESYS_PC_170_NV_USR2DIGIC_M2M_CONCURRENT: 831,
    GENESYS_PC_170_NV_PCSFAN_ANNUALPREPAY_NAMED: 832,
    GENESYS_PC_170_NV_PCSFANC_ANNUALPREPAY_CONCURRENT: 833,
    GENESYS_PC_170_NV_PCSFAN_ANNUALM2M_NAMED: 834,
    GENESYS_PC_170_NV_PCSFANC_ANNUALM2M_CONCURRENT: 835,
    GENESYS_PC_170_NV_PCSFAN_M2M_NAMED: 836,
    GENESYS_PC_170_NV_PCSFANC_M2M_CONCURRENT: 837,
    GENESYS_PC_170_NV_PCSFCAN_ANNUALPREPAY_NAMED: 838,
    GENESYS_PC_170_NV_PCSFCAN_ANNUALM2M_NAMED: 839,
    GENESYS_PC_170_NV_PCSFCAN_M2M_NAMED: 840,
    GENESYS_DIGITAL_2_ANNUALPREPAY_NAMED: 841,
    GENESYS_DIGITAL_2_ANNUALM2M_NAMED: 842,
    GENESYS_DIGITAL_2_ANNUALPREPAY_CONCURRENT: 843,
    GENESYS_DIGITAL_2_ANNUALM2M_CONCURRENT: 844,
    GENESYS_DIGITAL_3_ANNUALPREPAY_NAMED: 845,
    GENESYS_DIGITAL_3_ANNUALM2M_NAMED: 846,
    GENESYS_DIGITAL_3_ANNUALPREPAY_CONCURRENT: 847,
    GENESYS_DIGITAL_3_ANNUALM2M_CONCURRENT: 848,
    GENESYS_CX_AI_EXPERIENCE_FOR_DIGITAL_ANNUALPREPAY_NAMED: 849,
    GENESYS_CX_AI_EXPERIENCE_FOR_DIGITAL_ANNUALM2M_NAMED: 850,
    GENESYS_CX_AI_EXPERIENCE_FOR_DIGITAL_ANNUALPREPAY_CONCURRENT: 851,
    GENESYS_CX_AI_EXPERIENCE_FOR_DIGITAL_ANNUALM2M_CONCURRENT: 852,
    GENESYS_CX_AI_EXPERIENCE_ANNUALPREPAY_NAMED: 853,
    GENESYS_CX_AI_EXPERIENCE_ANNUALM2M_NAMED: 854,
    GENESYS_CX_AI_EXPERIENCE_ANNUALPREPAY_CONCURRENT: 855,
    GENESYS_CX_AI_EXPERIENCE_ANNUALM2M_CONCURRENT: 856,
    GENESYS_170_NV_USR2WEMI_ANNUALPREPAY_NAMED: 857,
    GENESYS_170_NV_USR2WEMI_ANNUALM2M_NAMED: 858,
    GENESYS_170_NV_USR2WEMIC_ANNUALPREPAY_CONCURRENT: 859,
    GENESYS_170_NV_USR2WEMIC_ANNUALM2M_CONCURRENT: 860,
    RINGCENTRAL_UC_BASIC_USER: 861,
    RINGCENTRAL_UC_ESSENTIAL_USER: 862,
    RINGCENTRAL_UC_STANDARD_USER_ANNUAL_TIER1: 863,
    RINGCENTRAL_UC_PREMIUM_USER_ANNUAL_TIER1: 864,
    RINGCENTRAL_UC_ULTIMATE_USER_ANNUAL_TIER1: 865,
    RINGCENTRAL_UC_STANDARD_USER_ANNUAL_TIER2: 866,
    RINGCENTRAL_UC_PREMIUM_USER_ANNUAL_TIER2: 867,
    RINGCENTRAL_UC_ULTIMATE_USER_ANNUAL_TIER2: 868,
    RINGCENTRAL_UC_STANDARD_USER_ANNUAL_TIER3: 869,
    RINGCENTRAL_UC_PREMIUM_USER_ANNUAL_TIER3: 870,
    RINGCENTRAL_UC_ULTIMATE_USER_ANNUAL_TIER3: 871,
    RINGCENTRAL_UC_STANDARD_USER_MONTHLY_TIER1: 872,
    RINGCENTRAL_UC_PREMIUM_USER_MONTHLY_TIER1: 873,
    RINGCENTRAL_UC_ULTIMATE_USER_MONTHLY_TIER1: 874,
    RINGCENTRAL_UC_STANDARD_USER_MONTHLY_TIER2: 875,
    RINGCENTRAL_UC_PREMIUM_USER_MONTHLY_TIER2: 876,
    RINGCENTRAL_UC_ULTIMATE_USER_MONTHLY_TIER2: 877,
    RINGCENTRAL_UC_STANDARD_USER_MONTHLY_TIER3: 878,
    RINGCENTRAL_UC_PREMIUM_USER_MONTHLY_TIER3: 879,
    RINGCENTRAL_UC_ULTIMATE_USER_MONTHLY_TIER3: 880,
    RINGCENTRAL_UC_CXNOW_INT: 881,
    RINGCENTRAL_UC_LIVE_REPORTS: 882,
    RINGCENTRAL_UC_INVIEW_MGT: 883,
    RINGCENTRAL_UC_ADD_NUMBER: 884,
    RINGCENTRAL_UC_MSFT_DYNAMICS: 885,
    RINGCENTRAL_CC_DIGITAL_AGENT: 886,
    RINGCENTRAL_CC_ESSENTIALS_AGENT: 887,
    RINGCENTRAL_CC_STANDARD_AGENT: 888,
    RINGCENTRAL_CC_SURVEY_MNGR: 889,
    RINGCENTRAL_CC_WORKFORCE_MGT_PRO: 890,
    RINGCENTRAL_CC_QUALITY_MGT_PRO: 891,
    RINGCENTRAL_CC_SCREEN_REC_PRO: 892,
    RINGCENTRAL_CC_QTY_MGT_ANLY_PRO: 893,
    RINGCENTRAL_CC_OMNI_ANLY_PRO: 894,
    RINGCENTRAL_CC_SF_AGT: 895,
    RINGCENTRAL_CC_ZEN_AGENT: 896,
    RINGCENTRAL_CC_PREMIUM_AGENT: 899,
    RINGCENTRAL_CC_ULTIMATE_AGENT: 900,
    RINGCENTRAL_CC_UNLIMITED_AGENT: 901,
    SIP_ACTIVE_36: 902,
    SIP_STANDBY_36: 903,
    SIP_ACTIVE_12: 904,
    SIP_STANDBY_12: 905,
    NETCALL_12MONTH: 906,
    NETCALL_36MONTH: 907,
    NETCALL_60MONTH: 908,
    RINGCENTRAL_TEAMS_SUBSCRIPTION_USER_5USERSPERCHANNEL_TIER1: 909,
    RINGCENTRAL_TEAMS_SUBSCRIPTION_USER_5USERSPERCHANNEL_TIER2: 910,
    RINGCENTRAL_TEAMS_SUBSCRIPTION_USER_1USERPERCHANNEL_TIER1: 911,
    RINGCENTRAL_TEAMS_SUBSCRIPTION_USER_1USERPERCHANNEL_TIER2: 912,
    RINGCENTRAL_TEAMS_SUBSCRIPTION_USER_3USERSPERCHANNEL_TIER1: 913,
    RINGCENTRAL_TEAMS_SUBSCRIPTION_USER_3USERSPERCHANNEL_TIER2: 914,
    RINGCENTRAL_TEAMS_SUBSCRIPTION_USER_1_2_USERSPERCHANNEL_TIER1: 915,
    RINGCENTRAL_TEAMS_SUBSCRIPTION_USER_1_2_USERSPERCHANNEL_TIER2: 916,
    RINGCENTRAL_TEAMS_SUBSCRIPTION_USER_7USERSPERCHANNEL_TIER1: 917,
    RINGCENTRAL_TEAMS_SUBSCRIPTION_USER_7USERSPERCHANNEL_TIER2: 918,
    RINGCENTRAL_TEAMS_SUBSCRIPTION_USER_10USERSPERCHANNEL_TIER1: 919,
    RINGCENTRAL_TEAMS_SUBSCRIPTION_USER_10USERSPERCHANNEL_TIER2: 920,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_1001_PLUS: 921,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_2001_PLUS: 922,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_3001_PLUS: 923,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_4001_PLUS: 924,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_5001_PLUS: 925,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_6001_PLUS: 926,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_7001_PLUS: 927,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_8001_PLUS: 928,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_9001_PLUS: 929,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_11001_PLUS: 930,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_12001_PLUS: 931,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_13001_PLUS: 932,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_14001_PLUS: 933,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_15001_PLUS: 934,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_16001_PLUS: 935,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_17001_PLUS: 936,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_18001_PLUS: 937,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_19001_PLUS: 938,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_20001_PLUS: 939,
    MITELUC_E2_UC_TELEPHONY_USER_1M: 940,
    MITELUC_E2_UC_TELEPHONY_USER_12M: 941,
    MITELUC_E2_UC_TELEPHONY_USER_36M: 942,
    MITELUC_E2_UC_TELEPHONY_USER_60M: 943,
    MITELUC_E2_UC_ENTRY_USER_1M: 944,
    MITELUC_E2_UC_ENTRY_USER_12M: 945,
    MITELUC_E2_UC_ENTRY_USER_36M: 946,
    MITELUC_E2_UC_ENTRY_USER_60M: 947,
    MITELUC_E2_UC_PREMIER_USER_1M: 948,
    MITELUC_E2_UC_PREMIER_USER_12M: 949,
    MITELUC_E2_UC_PREMIER_USER_36M: 950,
    MITELUC_E2_UC_PREMIER_USER_60M: 951,
    MITELUC_E2_UC_ELITE_CX_USER_1M: 952,
    MITELUC_E2_UC_ELITE_CX_USER_12M: 953,
    MITELUC_E2_UC_ELITE_CX_USER_36M: 954,
    MITELUC_E2_UC_ELITE_CX_USER_60M: 955,
    MITELUC_E2_UC_HOSP_GUESTROOM_1M: 956,
    MITELUC_E2_UC_HOSP_GUESTROOM_12M: 957,
    MITELUC_E2_UC_HOSP_GUESTROOM_36M: 958,
    MITELUC_E2_UC_HOSP_GUESTROOM_60M: 959,
    MITELUC_E2_UC_HOSP_STAFFMEMBER_1M: 960,
    MITELUC_E2_UC_HOSP_STAFFMEMBER_12M: 961,
    MITELUC_E2_UC_HOSP_STAFFMEMBER_36M: 962,
    MITELUC_E2_UC_HOSP_STAFFMEMBER_60M: 963,
    MITELUC_E2_UC_SRC_3RD_PARTY_RECORD_1M: 964,
    MITELUC_E2_UC_SRC_3RD_PARTY_RECORD_12M: 965,
    MITELUC_E2_UC_SRC_3RD_PARTY_RECORD_36M: 966,
    MITELUC_E2_UC_SRC_3RD_PARTY_RECORD_60M: 967,
    MITELUC_E2_CC_BUSINESS_REPORTER_CLIENT_1M: 968,
    MITELUC_E2_CC_BUSINESS_REPORTER_CLIENT_12M: 969,
    MITELUC_E2_CC_BUSINESS_REPORTER_CLIENT_36M: 970,
    MITELUC_E2_CC_BUSINESS_REPORTER_CLIENT_60M: 971,
    MITELUC_E2_CC_SYSTEM_ADMIN_1M: 972,
    MITELUC_E2_CC_SYSTEM_ADMIN_12M: 973,
    MITELUC_E2_CC_SYSTEM_ADMIN_36M: 974,
    MITELUC_E2_CC_SYSTEM_ADMIN_60M: 975,
    MITELUC_E2_CC_SOFTPHONE_1M: 976,
    MITELUC_E2_CC_SOFTPHONE_12M: 977,
    MITELUC_E2_CC_SOFTPHONE_36M: 978,
    MITELUC_E2_CC_SOFTPHONE_60M: 979,
    MITELUC_E2_CC_MULTIMEDIA_AGENT_1M: 980,
    MITELUC_E2_CC_MULTIMEDIA_AGENT_12M: 981,
    MITELUC_E2_CC_MULTIMEDIA_AGENT_36M: 982,
    MITELUC_E2_CC_MULTIMEDIA_AGENT_60M: 983,
    MITELUC_E2_CC_SCHEDULING_AGENT_1M: 984,
    MITELUC_E2_CC_SCHEDULING_AGENT_12M: 985,
    MITELUC_E2_CC_SCHEDULING_AGENT_36M: 986,
    MITELUC_E2_CC_SCHEDULING_AGENT_60M: 987,
    MITELUC_E2_CC_IVR_PORT_1M: 988,
    MITELUC_E2_CC_IVR_PORT_12M: 989,
    MITELUC_E2_CC_IVR_PORT_36M: 990,
    MITELUC_E2_CC_IVR_PORT_60M: 991,
    MITELUC_E2_CC_REMOTE_REDUN_IVR_STARTER_PACK_1M: 992,
    MITELUC_E2_CC_REMOTE_REDUN_IVR_STARTER_PACK_12M: 993,
    MITELUC_E2_CC_REMOTE_REDUN_IVR_STARTER_PACK_36M: 994,
    MITELUC_E2_CC_REMOTE_REDUN_IVR_STARTER_PACK_60M: 995,
    MITELUC_E2_RECORDING_ESSENTIALS_1M: 996,
    MITELUC_E2_RECORDING_ESSENTIALS_12M: 997,
    MITELUC_E2_RECORDING_ESSENTIALS_36M: 998,
    MITELUC_E2_RECORDING_ESSENTIALS_60M: 999,
    MITELUC_E2_RECORDING_PREMIER_1M: 1000,
    MITELUC_E2_RECORDING_PREMIER_12M: 1001,
    MITELUC_E2_RECORDING_PREMIER_36M: 1002,
    MITELUC_E2_RECORDING_PREMIER_60M: 1003,
    MITELUC_E2_RECORDING_ELITE_1M: 1004,
    MITELUC_E2_RECORDING_ELITE_12M: 1005,
    MITELUC_E2_RECORDING_ELITE_36M: 1006,
    MITELUC_E2_RECORDING_ELITE_60M: 1007,
    MITELUC_E2_RECORDING_PARALLEL_1M: 1008,
    MITELUC_E2_RECORDING_PARALLEL_12M: 1009,
    MITELUC_E2_RECORDING_PARALLEL_36M: 1010,
    MITELUC_E2_RECORDING_PARALLEL_60M: 1011,
    SIP_GAMMA_STCM_DDI_INCE_ADD_OVER_1K_10001_PLUS: 1012 /* Isn't in sequence, because was missed on original SQL insert */,            
    UNIFY_OPENSCAPE_VOICE_BASE: 1013,
    UNIFY_OPENSCAPE_VOICE_REDUNDANCY: 1014,
    UNIFY_OPENSCAPE_VOICE_DYNAMIC_USER: 1015,
    UNIFY_OPENSCAPE_UNIFY_PHONE_BASE: 1016,
    UNIFY_OPENSCAPE_VOICE_UNIFY_PHONE_USER: 1017,
    UNIFY_OPENSCAPE_XPRESSIONS_BASE: 1018,
    UNIFY_OPENSCAPE_XPRESSIONS_VOICE_USER: 1019,
    UNIFY_OPENSCAPE_XPRESSIONS_UNIFIED_USER: 1020,
    UNIFY_OPENSCAPE_UC_APPLICATION_BASE: 1021,
    UNIFY_OPENSCAPE_UC_APPLICATION_REDUNDANCY: 1022,
    UNIFY_OPENSCAPE_UC_APPLICATION_5_USER: 1023,
    UNIFY_OPENSCAPE_UC_APPLICATION_RECORDING: 1024,
    UNIFY_OPENSCAPE_UC_APPLICATION_AUTO_ATTENDANT: 1025,
    UNIFY_OPENSCAPE_BRANCH_REDUNDANCY: 1026,
    UNIFY_OPENSCAPE_SBC_BASE: 1027,
    UNIFY_OPENSCAPE_SBC_SESSION: 1028,
    UNIFY_OPENSCAPE_SBC_MICROPENSCAPEOFT_DIRECT_ROUTING_BASE: 1029,
    UNIFY_OPENSCAPE_SBC_REDUNDANCY_BASE: 1030,
    UNIFY_OPENSCAPE_CONCIERGE_PROFESSIONAL_USER: 1031,
    UNIFY_OPENSCAPE_DLS_BASE: 1032,
    UNIFY_OPENSCAPE_CMP_BASE: 1033,
    UNIFY_OPENSCAPE_CONCIERGE_BASE: 1034,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_1YR_20_99_USERS_NAMED: 1039,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_1YR_100_199_USERS_NAMED: 1040,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_1YR_200_399_USERS_NAMED: 1041,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_1YR_400_USERS_NAMED: 1042,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_3YR_20_99_USERS_NAMED: 1043,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_3YR_100_199_USERS_NAMED: 1044,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_3YR_200_399_USERS_NAMED: 1045,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_3YR_400_USERS_NAMED: 1046,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_5YR_20_99_USERS_NAMED: 1047,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_5YR_100_199_USERS_NAMED: 1048,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_5YR_200_399_USERS_NAMED: 1049,
    AVAYA_AXP_DIGITAL_ONLY_BUNDLE_5YR_400_USERS_NAMED: 1050,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_1YR_20_99_USERS_NAMED: 1051,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_1YR_100_199_USERS_NAMED: 1052,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_1YR_200_399_USERS_NAMED: 1053,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_1YR_400_USERS_NAMED: 1054,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_3YR_20_99_USERS_NAMED: 1055,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_3YR_100_199_USERS_NAMED: 1056,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_3YR_200_399_USERS_NAMED: 1057,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_3YR_400_USERS_NAMED: 1058,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_5YR_20_99_USERS_NAMED: 1059,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_5YR_100_199_USERS_NAMED: 1060,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_5YR_200_399_USERS_NAMED: 1061,
    AVAYA_AXP_VOICE_ONLY_BUNDLE_5YR_400_USERS_NAMED: 1062,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_1YR_20_99_USERS_NAMED: 1063,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_1YR_100_199_USERS_NAMED: 1064,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_1YR_200_399_USERS_NAMED: 1065,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_1YR_400_USERS_NAMED: 1066,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_3YR_20_99_USERS_NAMED: 1067,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_3YR_100_199_USERS_NAMED: 1068,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_3YR_200_399_USERS_NAMED: 1069,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_3YR_400_USERS_NAMED: 1070,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_5YR_20_99_USERS_NAMED: 1071,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_5YR_100_199_USERS_NAMED: 1072,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_5YR_200_399_USERS_NAMED: 1073,
    AVAYA_AXP_ALL_MEDIA_BUNDLE_5YR_400_USERS_NAMED: 1074,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_1YR_20_99_USERS_NAMED: 1075,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_1YR_100_199_USERS_NAMED: 1076,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_1YR_200_399_USERS_NAMED: 1077,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_1YR_400_USERS_NAMED: 1078,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_3YR_20_99_USERS_NAMED: 1079,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_3YR_100_199_USERS_NAMED: 1080,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_3YR_200_399_USERS_NAMED: 1081,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_3YR_400_USERS_NAMED: 1082,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_5YR_20_99_USERS_NAMED: 1083,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_5YR_100_199_USERS_NAMED: 1084,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_5YR_200_399_USERS_NAMED: 1085,
    AVAYA_AXP_WORKFORCE_MANAGEMENT_5YR_400_USERS_NAMED: 1086,
    AVAYA_AXP_SCREEN_RECORDING_1YR_20_99_USERS_NAMED: 1087,
    AVAYA_AXP_SCREEN_RECORDING_1YR_100_199_USERS_NAMED: 1088,
    AVAYA_AXP_SCREEN_RECORDING_1YR_200_399_USERS_NAMED: 1089,
    AVAYA_AXP_SCREEN_RECORDING_1YR_400_USERS_NAMED: 1090,
    AVAYA_AXP_SCREEN_RECORDING_3YR_20_99_USERS_NAMED: 1091,
    AVAYA_AXP_SCREEN_RECORDING_3YR_100_199_USERS_NAMED: 1092,
    AVAYA_AXP_SCREEN_RECORDING_3YR_200_399_USERS_NAMED: 1093,
    AVAYA_AXP_SCREEN_RECORDING_3YR_400_USERS_NAMED: 1094,
    AVAYA_AXP_SCREEN_RECORDING_5YR_20_99_USERS_NAMED: 1095,
    AVAYA_AXP_SCREEN_RECORDING_5YR_100_199_USERS_NAMED: 1096,
    AVAYA_AXP_SCREEN_RECORDING_5YR_200_399_USERS_NAMED: 1097,
    AVAYA_AXP_SCREEN_RECORDING_5YR_400_USERS_NAMED: 1098,
    AVAYA_AXP_QUALITY_MANAGEMENT_1YR_20_99_USERS_NAMED: 1099,
    AVAYA_AXP_QUALITY_MANAGEMENT_1YR_100_199_USERS_NAMED: 1100,
    AVAYA_AXP_QUALITY_MANAGEMENT_1YR_200_399_USERS_NAMED: 1101,
    AVAYA_AXP_QUALITY_MANAGEMENT_1YR_400_USERS_NAMED: 1102,
    AVAYA_AXP_QUALITY_MANAGEMENT_3YR_20_99_USERS_NAMED: 1103,
    AVAYA_AXP_QUALITY_MANAGEMENT_3YR_100_199_USERS_NAMED: 1104,
    AVAYA_AXP_QUALITY_MANAGEMENT_3YR_200_399_USERS_NAMED: 1105,
    AVAYA_AXP_QUALITY_MANAGEMENT_3YR_400_USERS_NAMED: 1106,
    AVAYA_AXP_QUALITY_MANAGEMENT_5YR_20_99_USERS_NAMED: 1107,
    AVAYA_AXP_QUALITY_MANAGEMENT_5YR_100_199_USERS_NAMED: 1108,
    AVAYA_AXP_QUALITY_MANAGEMENT_5YR_200_399_USERS_NAMED: 1109,
    AVAYA_AXP_QUALITY_MANAGEMENT_5YR_400_USERS_NAMED: 1110
});

export const V1_UNITCOST_IDS = Object.freeze({
    ICON_REP_UC_SUP: 1,
    ICON_REP_CC_SUP: 2,
    ICON_VM_01: 3,
    ICON_OS_WIN_UC: 4,
    ICON_OS_WIN_CC: 5,
    ICON_DB_SQL_UC: 6,
    ICON_DB_SQL_CC: 7,
    ICON_MNT_01: 8,
    ICON_DC_01: 9,
    ICON_PS_IOH_01: 10,
    ICON_PS_OOH_01: 11,
    ICON_BAK_01_SUP: 12,
    ICON_BLD_STD_01_SUP: 13,
    ICON_BLD_HPR_01_SUP: 14,
    ICON_CHA_01_SUP: 15,
    ICON_CHA_01: 16,
    ICON_SRG_FST_UC: 17,
    ICON_SRG_FST_CC: 18,
    ICON_SRG_BAK_UC: 19,
    ICON_SRG_BAK_CC: 20,
    ICON_SRG_ARC_UC: 21,
    ICON_SRG_ARC_CC: 22,
    ICON_BAK_UC: 23,
    ICON_BAK_CC: 24,
    ICON_REP_UC: 25,
    ICON_REP_CC: 26,
    SIP_SETUP_RESILIENT: 27,
    ICON_INF_ILC: 28,
    CXNOW_START_SMALL: 29,
    CXNOW_START_MEDIUM: 30,
    CXNOW_START_LARGE: 31,
    CXNOW_DIGITAL_SMALL: 32,
    CXNOW_DIGITAL_MEDIUM: 33,
    CXNOW_DIGITAL_LARGE: 34,
    CXNOW_CRM_SF_STD: 35,
    CXNOW_CRM_SF_CUSTOM: 36,
    CXNOW_CRM_MS_365_STD: 37,
    CXNOW_CRM_MS_365_CUSTOM: 38,
    CXNOW_CRM_MS_PREMISE_STD: 39,
    CXNOW_CRM_MS_PREMISE_CUSTOM: 40,
    CXNOW_CHATBOT_STANDALONE: 41,
    CXNOW_CHATBOT_INTEGRATION: 42,
    CXNOW_GAMMA_SIP_SETUP: 43,
    CXNOW_CCIS_SERVER_SMALL: 44,
    CXNOW_CCIS_SERVER_MEDIUM: 45,
    CXNOW_CCIS_SERVER_LARGE: 46,
    ICON_PORTAL: 47,
    AVAYA_USAGE_MONITORING: 48,
    ICON_COMMUNICATE_SBC_PORT_CHARGE: 49,
    ICON_GATEWAY_FAREHAM_RACK: 50,
    ICON_GATEWAY_GOSWELL_RACK: 51,
    ICON_GATEWAY_FAREHAM_LINK: 52,
    ICON_GATEWAY_GOSWELL_LINK: 53,
    ICON_GATEWAY_FAREHAM_WAN_DUAL_FEED: 54,
    ICON_GATEWAY_GOSWELL_WAN_DUAL_FEED: 55,
    ICON_GATEWAY_FAREHAM_WAN_GOLD: 56,
    ICON_GATEWAY_GOSWELL_WAN_GOLD: 57,
    ICON_GATEWAY_FAREHAM_WAN_SILVER: 58,
    ICON_GATEWAY_GOSWELL_WAN_SILVER: 59,
    ICON_GATEWAY_FAREHAM_WAN_BRONZE: 60,
    ICON_GATEWAY_GOSWELL_WAN_BRONZE: 61,
    CXNOW_PS_PROVISIONING: 62,
    CXNOW_PS_PROJECT_COORDINATOR: 63,
    CXNOW_PS_APPLICATIONS_CONSULTANT: 64,
    CXNOW_PS_PRODUCT_SPECIALIST: 65,
    CXNOW_PS_PRODUCT_SPECIALIST_HALFDAY: 66,
    CXNOW_PS_START_BUNDLE: 67,
    CXNOW_PS_DIGITAL_BUNDLE: 68,
    SIP_GAMMA_ML_GREATER_THAN_10_PORT: 69,
    SIP_GAMMA_OOH_EVE_PORT: 70,
    SIP_GAMMA_OOH_SAT_PORT: 71,
    SIP_CPE_STANDARD: 73,
    SIP_CPE_RESILIENT: 74,
    SIP_CORE_BANDWIDTH_STANDARD_UPFRONT_ICON_COMMUNICATE: 75,
    SIP_CORE_BANDWIDTH_RESILIENT_UPFRONT_ICON_COMMUNICATE: 76,
    SIP_CORE_BANDWIDTH_STANDARD_MONTHLY_ICON_COMMUNICATE: 77,
    SIP_CORE_BANDWIDTH_RESILIENT_MONTHLY_ICON_COMMUNICATE: 78,
    SIP_PS_PROJECT_MANAGEMENT: 79,
    SIP_PS_PROFESSIONAL_SERVICES: 80,
    SIP_STCM_INSTALL: 81,
    SIP_HELPDESK_INTERNAL: 82,
    SIP_HELPDESK_EXTERNAL: 83,
    SIP_ACCESS_GOLD: 84,
    SIP_ACCESS_SILVER: 85,
    SIP_ACCESS_GOLD_PLUS_PLUS: 86,
    SIP_ACCESS_GOLD_PLUS: 87,
    SIP_ACCESS_SILVER_PLUS: 88,
    ICON_SIP_SBC_PORT_CHARGE: 89,
    SIP_GAMMA_NUMBER: 90,
    SIP_TRUNK_CALL_MANAGER_CHARGE: 91,
    SIP_CPE_ENABLE_2ND_PRI: 92,
    SIP_SETUP_STANDARD: 93,
    SIP_TTB_SETUP: 94,
    SIP_TTB_NUMBER: 95,
    SIP_TTB_SL_PORT: 96,
    SIP_TTB_ML_PORT: 97,
    SIP_TTB_ML_LESS_THAN_11_PORT: 98,
    SIP_TTB_ML_GREATER_THAN_10_PORT: 99,
    SIP_TTB_OOH_EVE_PORT: 100,
    SIP_TTB_OOH_SAT_PORT: 101,
    SIP_TTB_OOH_EVE_MIG: 102,
    SIP_TTB_OOH_SAT_MIG: 103,
    SIP_TRUNK_CALL_MANAGER_FREE: 104,
    TEAMS_PROJECT_COORDINATOR: 105,
    TEAMS_PROJECT_COORDINATION_OOH: 106,
    TEAMS_ENGINEER_LEVEL_B: 107,
    TEAMS_ENGINEERING_LEVEL_A: 108,
    TEAMS_ICON_BANDWIDTH_CONTRIBUTION: 109,
    TEAMS_MAINTEL_SBC_SUPPORT: 110,
    TEAMS_NEW_DDI: 111,
    TEAMS_SIP_SETUP: 112,
    TEAMS_SBC_PORT_CHARGE: 113,
    CXNOW_TALKATIVE_PRO_SERVICES: 114,
    CXNOW_PRO_SERVICES: 115,
    PHONEPLUS_CISCO_ATA: 116,
    PHONEPLUS_CISCO_PA100: 117,
    PHONEPLUS_PLANTRONICS_BLACKWIRE: 118,
    PHONEPLUS_POLYVOYAGER_5200: 119,
    PHONEPLUS_SENNHEISER_SC165: 120,
    PHONEPLUS_POLYCOM_VVX150: 121,
    PHONEPLUS_POLYCOM_VVX250: 122,
    PHONEPLUS_POLYCOM_VVX450: 123,
    PHONEPLUS_POLYCOM_POWER: 124,
    PHONEPLUS_DELIVERY_BAND1: 125,
    PHONEPLUS_DELIVERY_BAND2: 126,
    PHONEPLUS_DELIVERY_BAND3: 127,
    PHONEPLUS_DELIVERY_BAND4: 128,
    PHONEPLUS_DELIVERY_BAND5: 129,
    PHONEPLUS_DELIVERY_BAND6: 130,
    PHONEPLUS_DELIVERY_BAND7: 131,
    PHONEPLUS_DELIVERY_BAND8: 132,
    PHONEPLUS_NUMBER_PORTING: 133,
    PHONEPLUS_PORTING_WEEKDAY_EVE: 134,
    PHONEPLUS_PORTING_SATURDAY: 135,
    ICON_SEC_CERTIFICATE_RECURRING: 136,
    PHONEPLUS_PS_IOH_01: 137,
    PHONEPLUS_PS_OOH_01: 138,
    GENESYS_CSM: 139,
    GENESYS_MANAGEDSERVICES: 140,
    TEAMS_REC_ONBOARDING: 141,
    TEAMS_REC_TENANT_ACTIVATION: 142,
    SIP_GAMMA_SEMA_SETUP_UNDER_150: 143,
    SIP_GAMMA_SEMA_SETUP_150_PLUS: 144,
    SIPMIGRATION_EDGE_6000_901_C2E: 145,
    SIPMIGRATION_EDGE_PC_UK: 146,
    SIPMIGRATION_SHIPMENT: 147,
    SIPMIGRATION_VRVMS_902_C2E: 148,
    SIPMIGRATION_C2E_USAGE_100_SITE: 149,
    SIPMIGRATION_C2E_USAGE_1_100_SURV: 150,
    SIPMIGRATION_C2E_HELPDESK_SUPPORT: 151,
    SIPMIGRATION_MAINTEL_SUPPORT_SERVICE_MONTHLY: 152,
    SIP_STCM_SERVICE: 153,
    GENESYS_BYOC_CHARGE: 154,
    TEAMS_ENGINEERING_LEVEL_B_HALF_DAY: 155,
    TEAMS_PROJECT_COORDINATION_OOH_PROV_PORTING: 156,
    ICON_SRG_ARC_TB_2: 157,
    SIP_GAMMA_SL_PORT: 158,
    SIP_GAMMA_ML_PORT: 159,
    SIP_GAMMA_ML_LESS_THAN_11_PORT: 160,
    RINGCENTRAL_MANAGEDSERVICES: 161,
    RINGCENTRAL_PS: 162,
    RINGCENTRAL_CSM: 163,
    TEAMS_ATTENDANT_CONSOLE_MONTHLY: 164,
    TEAMS_ATTENDANT_CONSOLE_ANNUAL: 165,
    CXNOW_PS_INSTALLATIONS_ENGINEER: 166,
    CXNOW_PS_CLOUD_INFRASTRUCTURE_SPECIALIST: 167,
    ICON_COMMUNICATE_MANAGED_SERVICES: 168,
    ICON_COMMUNICATE_UPFRONT_INFRASTRUCTURE: 169,
    ICON_COMMUNICATE_RECURRING_INFRASTRUCTURE: 170,
    SIPMIGRATION_HARDWARE: 171,
    ICON_SEC_CERTIFICATE_UPFRONT: 172,
    SYCURIO_PS: 173,
    SYCURIO_PSP: 174,
    SYCURIO_MAINTEL_ANNUAL_ASSESSMENT: 175,
    SYCURIO_MAINTEL_SEGMENTATION_TEST: 176,
    SYCURIO_MAINTEL_VULNERABILITY_SCANNER: 177,
    SYCURIO_MAINTEL_SIEM_LICENSES: 178,
    SYCURIO_MAINTEL_SOC_HEADCOUNT: 179,
    SYCURIO_MAINTEL_CIRCUIT_COST: 180,
    DO_NOT_USE_ICON_COMMUNICATE_UPFRONT_INFRASTRUCTURE_QUOTE: 181,
    DO_NOT_USE_ICON_COMMUNICATE_RECURRING_INFRASTRUCTURE_QUOTE: 182,
    UC_ANALYTICS_PROJECT_DELIVERY_MANAGER: 183,
    UC_ANALYTICS_ENGINEERING_LEVEL_A: 184,
    ICON_SIP_RECURRING_INFRASTRUCTURE: 185,
    SIP_CORE_BANDWIDTH_STANDARD_UPFRONT_STANDALONE_SIP: 186,
    SIP_CORE_BANDWIDTH_RESILIENT_UPFRONT_STANDALONE_SIP: 187,
    SIP_CORE_BANDWIDTH_STANDARD_MONTHLY_STANDALONE_SIP: 188,
    SIP_CORE_BANDWIDTH_RESILIENT_MONTHLY_STANDALONE_SIP: 189,
    UC_ANALYTICS_SET_UP_FEE_PLUS_PACKAGE: 190,
    ICON_BLADE_SERVERS: 191,
    ICON_COMMUNICATE_UPFRONT_INFRASTRUCTURE_AMORTISED: 192,
    ICON_VM_01_CPU_BASED: 193,
    PHONEPLUS_YEALINK_DECT_REPEATER: 194,
    PHONEPLUS_YEALINK_DECT_W52H: 195,
    PHONEPLUS_YEALINK_DECT_W52P: 196,
    PHONEPLUS_YEALINK_DECT_W73H: 197,
    PHONEPLUS_YEALINK_DECT_W73P: 198,
    NETCALL_PROJECT_COORDINATION_HALF_DAY: 199,
    NETCALL_LEAD_ENGINEER_HALF_DAY: 200,
    NETCALL_PROJECT_COORDINATION_DAY: 201,
    NETCALL_LEAD_ENGINEER_DAY: 202,          
    SIP_GAMMA_STCM_DDI_CONNECTION: 203
});

export const V1_QUOTE_ONLY_LICENCES = [
    V1_LICENCE_IDS.SIP_MIGRATION,
    V1_LICENCE_IDS.UC_ANALYTICS_FOUNDATION_USER_QUOTE_ONLY
]

export const V1_QUOTE_ONLY_UNITCOSTS = [
    V1_UNITCOST_IDS.SIP_TRUNK_CALL_MANAGER_CHARGE,
    V1_UNITCOST_IDS.SIP_TRUNK_CALL_MANAGER_FREE,
    V1_UNITCOST_IDS.ICON_COMMUNICATE_MANAGED_SERVICES,
    V1_UNITCOST_IDS.ICON_COMMUNICATE_UPFRONT_INFRASTRUCTURE,
    V1_UNITCOST_IDS.ICON_COMMUNICATE_RECURRING_INFRASTRUCTURE,
    V1_UNITCOST_IDS.DO_NOT_USE_ICON_COMMUNICATE_UPFRONT_INFRASTRUCTURE_QUOTE,
    V1_UNITCOST_IDS.DO_NOT_USE_ICON_COMMUNICATE_RECURRING_INFRASTRUCTURE_QUOTE,
    V1_UNITCOST_IDS.ICON_SIP_RECURRING_INFRASTRUCTURE,
    V1_UNITCOST_IDS.ICON_COMMUNICATE_UPFRONT_INFRASTRUCTURE_AMORTISED
]

const V1_CATEGORIES = ["Infrastructure", "Licences", "Professional Services", "Support", "Other"];

export const  V1_PS_UNITCOSTS = [
    V1_UNITCOST_IDS.TEAMS_PROJECT_COORDINATOR,
    V1_UNITCOST_IDS.TEAMS_PROJECT_COORDINATION_OOH,
    V1_UNITCOST_IDS.TEAMS_ENGINEER_LEVEL_B,
    V1_UNITCOST_IDS.TEAMS_ENGINEERING_LEVEL_A,
    V1_UNITCOST_IDS.SIP_PS_PROJECT_MANAGEMENT,
    V1_UNITCOST_IDS.SIP_PS_PROFESSIONAL_SERVICES,
    V1_UNITCOST_IDS.PHONEPLUS_PS_IOH_01,
    V1_UNITCOST_IDS.PHONEPLUS_PS_OOH_01,
    V1_UNITCOST_IDS.TEAMS_REC_ONBOARDING,
    V1_UNITCOST_IDS.TEAMS_REC_TENANT_ACTIVATION,
    V1_UNITCOST_IDS.TEAMS_ENGINEERING_LEVEL_B_HALF_DAY,
    V1_UNITCOST_IDS.TEAMS_PROJECT_COORDINATION_OOH_PROV_PORTING,
    V1_UNITCOST_IDS.UC_ANALYTICS_PROJECT_DELIVERY_MANAGER,
    V1_UNITCOST_IDS.UC_ANALYTICS_ENGINEERING_LEVEL_A
]

export const V1_INFRASTRUCTURE_UNITCOSTS = [
    /**
     * 1	ICON VM Replication Licensing - Support Only (UC)
2	ICON VM Replication Licensing - Support Only (CC)
3	ICON Virtualisation hypervisor
4	ICON Windows Server Operating System (UC)
5	ICON Windows Server Operating System (CC)
6	ICON SQL database server licensing (UC)
7	ICON SQL database server licensing (CC)
8	ICON VM monitoring licensing
9	ICON DC hosting
10	ICON PS IOH
11	ICON PS OOH
12	ICON VM Backup Licensing - Support Only
13	ICON Standard Blade Server - Support Only
14	ICON High Powered Blade Server - Support Only
15	ICON Blade Server Chassis - Support Only
16	ICON Blade Server Chassis
17	ICON Fast Storage TB (UC)
18	ICON Fast Storage TB (CC)
19	ICON Backup Storage TB (UC)
20	ICON Backup Storage TB (CC)
21	ICON Archive Storage TB (UC)
22	ICON Archive Storage TB (CC)
23	ICON VM Backup Licensing (UC)
24	ICON VM Backup Licensing (CC)
25	ICON VM Replication Licensing (UC)
26	ICON VM Replication Licensing (CC)
28	Infrastructure In-Life Costs
48	Usage Metering
49	ICON SBC Port Charge
69	Multiline Porting Charge with DDI Block over 10
73	CPE Standard Access
74	CPE Resilient Access
75	Core Bandwidth Standard Upfront
76	Core Bandwidth Resilient Upfront
77	Core Bandwidth Standard Monthly Charge
78	Core Bandwidth Resilient Monthly Charge
81	SIP STCM Install
84	SIP Access Gold
85	SIP Access Silver
86	SIP Access Gold++
87	SIP Access Gold+
88	SIP Access Silver+
89	ICON SBC Port Charge
90	SIP Gamma Number
91	SIP Trunk Call Manager Charge
92	EM6000 LICENCE TO ENABLE 2nd PRI PORT
95	SIP TTB Number
104	SIP Trunk Call Manager 1-1000 free DDIs
109	ICON Bandwidth Contribution
110	Maintel SBC Support
113	ICON SBC Port Charge
136	ICON-Sec-Certificate
157	ICON Archive Storage TB
158	Single line Porting Charge
159	Multiline Porting Charge
160	Multiline Porting Charge with DDI Block 1 to 10
169	Infrastructure
170	Infrastructure
172	ICON-Sec-Certificate
181	Service Setup Charge
182	ICON Infrastructure Rental
185	Icon SIP Infrastructure
186	Core Bandwidth Standard Upfront
187	Core Bandwidth Resilient Upfront
188	Core Bandwidth Standard Monthly Charge
189	Core Bandwidth Resilient Monthly Charge
191	ICON Blade Servers
192	Infrastructure
193	ICON Virtualisation hypervisor
203	STCM DDI Connection
     */
    V1_UNITCOST_IDS.ICON_REP_UC_SUP,
    V1_UNITCOST_IDS.ICON_REP_CC_SUP,
    V1_UNITCOST_IDS.ICON_VM_01,
    V1_UNITCOST_IDS.ICON_OS_WIN_UC,
    V1_UNITCOST_IDS.ICON_OS_WIN_CC,
    V1_UNITCOST_IDS.ICON_DB_SQL_UC,
    V1_UNITCOST_IDS.ICON_DB_SQL_CC,
    V1_UNITCOST_IDS.ICON_MNT_01,
    V1_UNITCOST_IDS.ICON_DC_01,
    V1_UNITCOST_IDS.ICON_PS_IOH_01,
    V1_UNITCOST_IDS.ICON_PS_OOH_01,
    V1_UNITCOST_IDS.ICON_BAK_01_SUP,
    V1_UNITCOST_IDS.ICON_BLD_STD_01_SUP,
    V1_UNITCOST_IDS.ICON_BLD_HPR_01_SUP,
    V1_UNITCOST_IDS.ICON_CHA_01_SUP,
    V1_UNITCOST_IDS.ICON_CHA_01,
    V1_UNITCOST_IDS.ICON_SRG_FST_UC,
    V1_UNITCOST_IDS.ICON_SRG_FST_CC,
    V1_UNITCOST_IDS.ICON_SRG_BAK_UC,
    V1_UNITCOST_IDS.ICON_SRG_BAK_CC,
    V1_UNITCOST_IDS.ICON_SRG_ARC_UC,
    V1_UNITCOST_IDS.ICON_SRG_ARC_CC,
    V1_UNITCOST_IDS.ICON_BAK_UC,
    V1_UNITCOST_IDS.ICON_BAK_CC,
    V1_UNITCOST_IDS.ICON_REP_UC,
    V1_UNITCOST_IDS.ICON_REP_CC,
    V1_UNITCOST_IDS.ICON_INF_ILC,
    V1_UNITCOST_IDS.AVAYA_USAGE_MONITORING,
    V1_UNITCOST_IDS.ICON_COMMUNICATE_SBC_PORT_CHARGE,
    V1_UNITCOST_IDS.SIP_GAMMA_ML_GREATER_THAN_10_PORT,
    V1_UNITCOST_IDS.SIP_CPE_STANDARD,
    V1_UNITCOST_IDS.SIP_CPE_RESILIENT,
    V1_UNITCOST_IDS.SIP_CORE_BANDWIDTH_STANDARD_UPFRONT_ICON_COMMUNICATE,
    V1_UNITCOST_IDS.SIP_CORE_BANDWIDTH_RESILIENT_UPFRONT_ICON_COMMUNICATE,
    V1_UNITCOST_IDS.SIP_CORE_BANDWIDTH_STANDARD_MONTHLY_ICON_COMMUNICATE,
    V1_UNITCOST_IDS.SIP_CORE_BANDWIDTH_RESILIENT_MONTHLY_ICON_COMMUNICATE,
    V1_UNITCOST_IDS.SIP_STCM_INSTALL,
    V1_UNITCOST_IDS.SIP_ACCESS_GOLD,
    V1_UNITCOST_IDS.SIP_ACCESS_SILVER,
    V1_UNITCOST_IDS.SIP_ACCESS_GOLD_PLUS_PLUS,
    V1_UNITCOST_IDS.SIP_ACCESS_GOLD_PLUS,
    V1_UNITCOST_IDS.SIP_ACCESS_SILVER_PLUS,
    V1_UNITCOST_IDS.ICON_SIP_SBC_PORT_CHARGE,
    V1_UNITCOST_IDS.SIP_GAMMA_NUMBER,
    V1_UNITCOST_IDS.SIP_TRUNK_CALL_MANAGER_CHARGE,
    V1_UNITCOST_IDS.SIP_CPE_ENABLE_2ND_PRI,
    V1_UNITCOST_IDS.SIP_TTB_NUMBER,
    V1_UNITCOST_IDS.SIP_TRUNK_CALL_MANAGER_FREE,
    V1_UNITCOST_IDS.TEAMS_ICON_BANDWIDTH_CONTRIBUTION,
    V1_UNITCOST_IDS.TEAMS_MAINTEL_SBC_SUPPORT,
    V1_UNITCOST_IDS.TEAMS_SBC_PORT_CHARGE,
    V1_UNITCOST_IDS.ICON_SEC_CERTIFICATE_RECURRING,
    V1_UNITCOST_IDS.ICON_SRG_ARC_TB_2,
    V1_UNITCOST_IDS.SIP_GAMMA_SL_PORT,
    V1_UNITCOST_IDS.SIP_GAMMA_ML_PORT,
    V1_UNITCOST_IDS.SIP_GAMMA_ML_LESS_THAN_11_PORT,
    V1_UNITCOST_IDS.ICON_COMMUNICATE_UPFRONT_INFRASTRUCTURE,
    V1_UNITCOST_IDS.ICON_COMMUNICATE_RECURRING_INFRASTRUCTURE,
    V1_UNITCOST_IDS.ICON_SEC_CERTIFICATE_UPFRONT,
    V1_UNITCOST_IDS.DO_NOT_USE_ICON_COMMUNICATE_UPFRONT_INFRASTRUCTURE_QUOTE,
    V1_UNITCOST_IDS.DO_NOT_USE_ICON_COMMUNICATE_RECURRING_INFRASTRUCTURE_QUOTE,
    V1_UNITCOST_IDS.ICON_SIP_RECURRING_INFRASTRUCTURE,
    V1_UNITCOST_IDS.SIP_CORE_BANDWIDTH_STANDARD_UPFRONT_STANDALONE_SIP,
    V1_UNITCOST_IDS.SIP_CORE_BANDWIDTH_RESILIENT_UPFRONT_STANDALONE_SIP,
    V1_UNITCOST_IDS.SIP_CORE_BANDWIDTH_STANDARD_MONTHLY_STANDALONE_SIP,
    V1_UNITCOST_IDS.SIP_CORE_BANDWIDTH_RESILIENT_MONTHLY_STANDALONE_SIP,
    V1_UNITCOST_IDS.ICON_BLADE_SERVERS,
    V1_UNITCOST_IDS.ICON_COMMUNICATE_UPFRONT_INFRASTRUCTURE_AMORTISED,
    V1_UNITCOST_IDS.ICON_VM_01_CPU_BASED,
    V1_UNITCOST_IDS.SIP_GAMMA_STCM_DDI_CONNECTION,

]